import React, { Component } from "react";

import { Redirect } from "react-router-dom";

import Loader from "../Loader";
import DialogR from "./DialogR";
import ServerIO from "./ServerIO";
import loginBanner from "../../assets/images/login-banner.png";
import lunchBanner from "../../assets/images/lunch-banner.png";
import ausenteBanner from "../../assets/images/ausente-banner.png";
/*
import c1 from "../../assets/images/calificaciones/1.png";
import c2 from "../../assets/images/calificaciones/2.png";
import c3 from "../../assets/images/calificaciones/3.png";
import c4 from "../../assets/images/calificaciones/4.png";
import c5 from "../../assets/images/calificaciones/5.png";
*/

import c1 from "../../assets/images/calificaciones/Calificacionfiguras-02.png";
import c2 from "../../assets/images/calificaciones/Calificacionfiguras-03.png";
import c3 from "../../assets/images/calificaciones/Calificacionfiguras-04.png";
import c4 from "../../assets/images/calificaciones/Calificacionfiguras-05.png";
import c5 from "../../assets/images/calificaciones/Calificacionfiguras-06.png";
import {
  checkPlanPatientBenef,
  checkPlanPatient,
  checkPlanPatientSAP,
  decodeToken,
  setAtencion,
  setFinAtencion,
  setCalificacion,
  getCookie,
  setReservaV2,
  getDiasByIdConsultorioYServicio,
  getMensajes,
  eliminarRefrigerio,
  getServicios,
  getDays,
  guardarPaciente,
  getMonths,
  getYears,
  setActualizaAtencion,
  validateForm,
} from "../functions.js";
import {
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBFormInline,
} from "mdbreact";
import IMG01 from "../../assets/images/Doctora_Dibujo-02.jpg";
import { MDBIcon, toast, ToastContainer } from "mdbreact";
import { io } from "socket.io-client";
import { useState, useEffect } from "react";

var connectionOptions = {
  "force new connection": true,
  reconnectionAttempts: "Infinity",
  timeout: 10000,
  transports: ["websocket", "polling", "flashsocket"],
};

const socket = io(process.env.REACT_APP_SIO_CONFIG);
//var minutos = 1

// el array de los videos
var vids = []; // ["/videos/vid2.mp4", "/videos/vid1.mp4"]
// la longitud del array de los videos
var leng = 0; // vids.length;
// un numero utilizado para saber que video se está reproduciendo
var n = 0;
// utilizo el evento "ended" para saber si el video se ha acabado

const horaFix = new Date();
class Reservations extends Component {
  constructor(props) {
    super(props);
    this.listenerAdded = false;

    this.myRef = React.createRef();
    this.handleEnded = this.handleEnded.bind(this);
    this.state = {
      //showCalificacionButton: true,
      dataCalificacion: {},
      isExecuting: false,
      showScreen: true,
      benefClinic: [],
      checkPlanPatient: null,
      servicios_nuevo: [],
      isPreparing: true,
      carnet_identidad_seleccionado: "",
      id_hora_doctor: 0,
      mensajes: [],
      invalids: {},
      active: 0,
      lookRef2: false,
      benef_email: "",
      modalConfirm15: false,
      benef_apellido_materno: "",
      benef_apellido_paterno: "",
      benef_cedula: "",
      benef_primer_nombre: "",
      //servicioNuevoBenef: "",
      DocEntry: "",
      benef_segundo_nombre: "",

      benef_phone: "",
      benef_expedicion: "",
      benef_extension: "",
      v_expedicion_T: [
        { text: "BE", value: "BE" },
        { text: "CB", value: "CB" },
        { text: "LP", value: "LP" },
        { text: "OR", value: "OR" },
        { text: "PD", value: "PD" },
        { text: "PT", value: "PT" },
        { text: "SC", value: "SC" },
        { text: "CH", value: "CH" },
        { text: "TJ", value: "TJ" },
        { text: "N/A", value: "" },
      ],
      noBreak: true,
      noVisit: true,
      noBreakVisit: true,
      id_hora_nuevo: 0,
      mensaje_atraso: "",
      benef_day: "01",
      benef_month: "01",
      benef_year: "2000",
      custommessage: "",
      benef_radioGenero: 1,
      parentescos: [
        { text: "Esposa", value: "Esposa" },
        { text: "Esposo", value: "Esposo" },
        { text: "Hijo", value: "Hijo" },
        { text: "Hija", value: "Hija" },
        { text: "Hermano", value: "Hermano" },
        { text: "Hermana", value: "Hermana" },
      ],
      carnet_identidad:
        process.env.REACT_APP_API_CONFIG === "http://localhost:2001/v2"
          ? "6060603"
          : "", //7271654 14241194
      goHome: false,
      mensaje_bienvenida_reserva: "",
      messageInnova: "",
      goRegister: false,
      benef_parentesco: "ESPOSA",
      mensajeNew: "",
      modalConfirm: false,
      modalConfirm2: false,
      modalConfirm3: false,
      modalConfirm4: false,
      modalConfirm5: false,
      modalConfirm6: false,
      modalConfirm7: false,
      modalConfirm8: false,

      modalConfirm9: false,
      modalConfirm10: false,
      modalConfirm11: false,

      modalConfirm12: false,
      modalConfirm13: false,
      modalConfirm14: false,

      tieneBenef: false,
      v_days_T: [],
      v_months_T: [],
      v_years_T: [],

      Beneficiarios: [],
      step1: true, // false,
      serviciosOrig: [],
      planes: [],
      servicios: [],
      modalR: false,
      refrigerioActivo: false,
      refrigerioActivoMon: false,
      horas_minino_reserva: 0,
      paciente_no_encontrado: "",
      mensaje_fuera_horario: "",
      id_servicio: 0,
      url_calificacion: "",
      Cod_oficina: "",
      horas_libres: [],
      hora: "",
      horas: [],
      minuto: "",
      minutoV: "",
      horaV: "",
      horaV2: "",
      minutoV2: "",
      minutos_ref: [],
      serviciosPacientePantalla: [],
      buttonsModalR: [
        {
          buttonAction: this.confirmarHora,
          buttonId: 1,
          buttonClass: "btn btn-success btn-sm",
          buttonName: "Registrar Cita",
        },
        {
          buttonAction: this.cancelHora,
          buttonId: 1,
          buttonClass: "btn btn-secondary btn-sm",
          buttonName: "Cancelar",
        },
      ],
    };
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalId);
    clearInterval(this.state.intervalId2);
  };

  handleClick = (value) => {
    this.setState((prevState) => ({
      carnet_identidad: prevState.carnet_identidad + "" + value,
    }));
  };

  componentDidMount = async () => {
    //this.myRef.current.play();

    console.log("v1.2");
    var horas = [];

    var v_days = getDays();
    var v_months = getMonths();
    var v_years = getYears();

    for (let i = 0; i < 24; i++) {
      var hora = ("0" + i).slice(-2); // Agrega un cero delante si es necesario
      horas.push({ text: hora, value: hora });
    }
    var minutos_ref = [
      { text: "00", value: "00" },
      { text: "30", value: "30" },
    ];
    /*
    for (let i = 0; i < 60; i += 10) {
      var minuto = ("0" + i).slice(-2); // Agrega un cero delante si es necesario
      minutos_ref.push({ text: minuto, value: minuto });
    }
    */

    socket.on("connect", () => console.log("usuario conectado"));

    let token = getCookie("tokenINNOVA2");
    var _resp = await decodeToken(token);

    clearInterval(this.state.intervalId);
    clearInterval(this.state.intervalId2);
    var intervalId2 = setInterval(this.gethorasLibres, 10 * 60 * 1000);

    this.setState({
      intervalId2: intervalId2,
      isExecuting: true,
      horas: horas,
      minutos_ref: minutos_ref,
      minuto: "00",
      v_days_T: v_days,
      v_months_T: v_months,
      v_years_T: v_years,
    });
    // console.log(minutos, horas)
    if (_resp.resp === "OK") {
      if (
        _resp.datos.rol === "Consultorio" ||
        _resp.datos.rol === "Doctor" ||
        _resp.datos.rol === "Monitor"
      ) {
        var respMensajes = await getMensajes();
        var respS = await getServicios();

        const Cod_empresa = getCookie("empresaINNOVA2");
        this.setState({
          ...this.state,
          mensaje_atraso: respMensajes.mensaje_atraso,
          varios: respMensajes.mensajesV2,
          minutos: respMensajes.minutos,
          mensaje_fuera_horario: respMensajes.mensaje_fuera_horario,
          horas_minino_reserva: respMensajes.horas_minino_reserva,
          servicios: respS.servicios,
          serviciosOrig: respS.servicios,
          id_consultorio: Cod_empresa,
          usuario_rol: _resp.datos.rol,
          refrigerioMensaje: respMensajes.refrigerioMensaje,
          visitaMensaje: respMensajes.mensajesV2.visitaMensaje,
          ausenteBanner: respMensajes.imagen_ausente,
          lunchBanner: respMensajes.imagen_lunch,
          loginBanner: respMensajes.imagen_login,
        });
        await this.gethorasLibres();

        let mensajes = respMensajes.mensajes_consultorio;

        //console.log(respMensajes.videos);
        vids = respMensajes.videos;
        leng = respMensajes.videos.length;
        //console.log("this.myRef", this.myRef);

        this.setState({
          ...this.state,
          rol: _resp.datos.rol,
          Cod_oficina: _resp.datos.Cod_oficina,
          consultorioInfo: _resp.datos,
          isExecuting: false,
          mensajes: mensajes,
        });

        var intervalId = setInterval(
          this.refreshActive,
          respMensajes.minutos * 60 * 1000
        );
        this.setState({ intervalId: intervalId });

        if (_resp.datos.rol === "Consultorio") {
          this.setState({
            ...this.state,
            showScreen: false,
            url_calificacion: respMensajes.url_calificacion,
            mensaje_bienvenida_reserva: respMensajes.mensaje_bienvenida_reserva,
            mensaje_atraso: respMensajes.mensaje_atraso,
            paciente_no_encontrado: respMensajes.paciente_no_encontrado,
            cita_reservada: respMensajes.cita_reservada,
          });
        }
      } else {
        this.setState({ ...this.state, goHome: true, isExecuting: false });
      }
    } else {
      this.setState({ ...this.state, goHome: true, isExecuting: false });
    }
    this.setState({ ...this.state, isPreparing: false });
  };

  onClickRadioGen_B = (nr) => () => {
    console.log("change", nr);
    this.setState({
      benef_radioGenero: nr,
    });
  };

  setReservaV2 = async () => {
    console.log("nuevaCompra", this.state.nuevaCompra);
    this.setState({ isExecuting: true, errorLogin: false });
    let selHora = this.state.selHora;
    //console.log("cons", this.state.consultorioInfo	, selHora)
    let token = getCookie("tokenINNOVA2");

    let pos = this.state.horas_libres.findIndex(
      (item) => selHora === item.hora_larga
    );

    //console.log(this.state.horas_libres[pos])
    let id_servicio = 0;
    let id_product = 0;
    let servicio = this.state.id_servicio;
    //console.log("servicios", this.state.servicios, servicio);
    let posS = this.state.servicios.findIndex(
      (item) => item.codSAP === servicio
    );
    if (posS >= 0) {
      id_servicio = this.state.servicios[posS].codServInnova;
      id_product = this.state.servicios[posS].id_product;
    }
    // console.log(this.state.servicios);

    let servicios_disponibles = [];

    this.state.servicios.map(function (key) {
      servicios_disponibles.push(key.id_product + "|" + key.codServInnova);
    });
    var resp = {};

    console.log("this.", this.state.nuevaCompra, this.state.carnet_identidad);
    if (this.state.nuevaCompra) {
      resp = await setReservaV2(
        this.state.carnet_identidad,
        "NUEVO",
        "PACIENTE",
        "NN",
        token,
        this.state.selHora,
        this.state.fechaActual,
        this.state.id_consultorio,
        this.state.idPaciente,
        "0",
        "0",
        "",
        this.state.carnet_identidad
      );
    } else {
      resp = await setReservaV2(
        this.state.tieneBenef
          ? this.state.carnet_identidad_seleccionado
          : this.state.carnet_identidad,
        this.state.nombre,
        this.state.apellido,
        this.state.plan,
        token,
        this.state.selHora,
        this.state.fechaActual,
        this.state.id_consultorio,
        this.state.idPaciente,
        id_servicio,
        id_product,
        servicios_disponibles.toString(),
        this.state.carnet_identidad
      );
    }

    if (resp.success) {
      await this.gethorasLibres();

      console.log("notif", {
        Cod_oficina: this.state.Cod_oficina,
        Cod_empresa: this.state.consultorioInfo.Cod_empresa,
        usuario: socket.id,
        paciente: this.state.nombre + " " + this.state.apellido,
        servicios: servicios_disponibles.toString(),
        hora: selHora,
        cedula: this.state.carnet_identidad_seleccionado,
        cedula_titular: this.state.carnet_identidad,
      });
      socket.emit("chat_solicitud", {
        Cod_oficina: this.state.Cod_oficina,
        Cod_empresa: this.state.consultorioInfo.Cod_empresa,
        usuario: socket.id,
        paciente: this.state.nuevaCompra
          ? "NUEVO PACIENTE"
          : this.state.nombre + " " + this.state.apellido,
        servicios: this.state.nuevaCompra
          ? ""
          : servicios_disponibles.toString(),
        hora: selHora,
        cedula: this.state.nuevaCompra
          ? this.state.carnet_identidad
          : this.state.carnet_identidad_seleccionado,
        cedula_titular: this.state.carnet_identidad,
      });

      this.setState({
        ...this.state,
        modalConfirm: false,
        modalConfirm15: false,
        /*showScreen: true,*/ errorLogin: false,
        isExecuting: false,
        carnet_identidad: "",
        carnet_identidad_seleccionado: "",
        checkPlanPatient: null,
        benefClinic: [],
        id_servicio: 0,
      });

      if (this.state.rol === "Consultorio") {
        this.setState({
          ...this.state,
          modalSucc: true,
          carnet_identidad: "",
          carnet_identidad_seleccionado: "",
          checkPlanPatient: null,
          benefClinic: [],
          step1: true, //false,
        });

        setTimeout(
          function () {
            this.setState({ ...this.state, modalSucc: false });
          }.bind(this),
          5000
        );
      }
    } else {
      console.log("RES", resp);

      this.setState({
        ...this.state,

        modalConfirm15: true,

        /*
        modalConfirm: false,
        id_servicio: 0,
        errorLogin: true,
        errorMessage: resp.message,
        */
        isExecuting: false,
      });
    }
  };

  setBreak = async (selHora) => {
    this.setState({ isExecuting: true, errorLogin: false });

    // console.log("cons", this.state.consultorioInfo, selHora);
    let token = getCookie("tokenINNOVA2");
    let resp = {};
    /*
    var resp = await setReservaV2(
      "Refrigerio",
      "Refrigerio del Doctor",
      "",
      "",
      token,
      selHora,
      this.state.fechaActual,
      this.state.id_consultorio,
      this.state.idPaciente
    );
*/
    //		console.log("RESP", resp)
    if (resp.success) {
      await this.gethorasLibres();
      /*
      socket.emit("chat_solicitud", {
        Cod_oficina: this.state.Cod_oficina,
        Cod_empresa: this.state.consultorioInfo.Cod_empresa,
        usuario: socket.id,
        paciente: this.state.nombre + " " + this.state.apellido,
        hora: selHora,
        cedula: this.state.carnet_identidad,
      });
*/
      this.setState({
        ...this.state,
        modalConfirm: false,
        /*showScreen: true,*/ errorLogin: false,
        isExecuting: false,
        carnet_identidad: "",
        carnet_identidad_seleccionado: "",
        checkPlanPatient: null,
        benefClinic: [],
        id_servicio: 0,
        noBreak: false,
      });

      if (this.state.rol === "Consultorio") {
        this.setState({ ...this.state, modalSucc: true });

        setTimeout(
          function () {
            this.setState({ ...this.state, modalSucc: false });
          }.bind(this),
          5000
        );
      }
    } else {
      this.setState({
        ...this.state,
        modalConfirm: false,
        id_servicio: 0,
        errorLogin: true,
        errorMessage: resp.message,
        isExecuting: false,
      });
    }
  };

  programarRefrigerio = async () => {
    var desde = this.state.hora + ":" + this.state.minuto;

    //console.log("d", desde)
    let hora = parseInt(this.state.hora, 10);
    let minutos = parseInt(this.state.minuto, 10);

    // Aumentar 30 minutos
    minutos += 30;

    // Verificar si se pasa de 60 minutos
    if (minutos >= 60) {
      minutos -= 60;
      hora += 1;
    }

    let horaFormateada = hora.toString().padStart(2, "0");
    let minutosFormateados = minutos.toString().padStart(2, "0");
    let hasta = `${horaFormateada}:${minutosFormateados}`;
    let selHora = desde + " - " + hasta;
    let token = getCookie("tokenINNOVA2");

    let ahora = new Date();

    let horaActual = ahora.getHours();
    let minutosActuales = ahora.getMinutes();

    // Convertir a números
    let hora2 = parseInt(this.state.hora, 10);
    let minutos2 = parseInt(this.state.minuto, 10);

    console.log("horaActua", horaActual, minutosActuales, hora2, minutos2);
    let isValid = false;
    if (
      hora2 > horaActual ||
      (hora2 === horaActual && minutos2 > minutosActuales)
    ) {
      isValid = true;
    } else if (hora === horaActual && minutos2 === minutosActuales) {
      isValid = true;
    }

    if (!isValid) {
      toast.error("La hora debe ser posterior a la actual", {
        closeButton: true,
      });
    } else {
      this.setState({ isExecuting: true, errorLogin: false });
      var resp = await setReservaV2(
        "Refrigerio",
        "Refrigerio del Doctor",
        "",
        "",
        token,
        selHora,
        this.state.fechaActual,
        this.state.id_consultorio,
        this.state.idPaciente
      );

      console.log("RESP", resp);
      if (resp.success) {
        await this.gethorasLibres();

        this.setState({
          ...this.state,
          modalConfirm4: false,
          errorLogin: false,
          isExecuting: false,
          carnet_identidad: "",
          carnet_identidad_seleccionado: "",
          checkPlanPatient: null,
          benefClinic: [],
          id_servicio: 0,
          noBreak: false,
        });

        socket.emit("chat_solicitud", {
          Cod_oficina: this.state.Cod_oficina,
          Cod_empresa: this.state.consultorioInfo.Cod_empresa,
          usuario: socket.id,
          paciente: "Refrigerio",
          hora: selHora,
          cedula: "Refrigerio",
        });

        if (this.state.rol === "Consultorio") {
          this.setState({ ...this.state, modalSucc: true });

          setTimeout(
            function () {
              this.setState({ ...this.state, modalSucc: false });
            }.bind(this),
            5000
          );
        }
      } else {
        toast.error(resp.message, {
          closeButton: true,
        });

        this.setState({
          ...this.state,
          //modalConfirm4: false,
          id_servicio: 0,
          errorLogin: true,
          errorMessage: resp.message,
          isExecuting: false,
        });
      }
    }
  };

  programarVisita = async () => {
    var desde = this.state.horaV + ":" + this.state.minutoV;
    var hasta = this.state.horaV2 + ":" + this.state.minutoV2;

    let hora = parseInt(this.state.horaV, 10);
    let minutos = parseInt(this.state.minutoV, 10);

    let hora2 = parseInt(this.state.horaV2, 10);
    let minutos2 = parseInt(this.state.minutoV2, 10);

    var desdeV = parseInt(this.state.horaV + this.state.minutoV);
    var hastaV = parseInt(this.state.horaV2 + this.state.minutoV2);

    //console.log(desdeV, hastaV);

    let selHora = desde + " - " + hasta;
    let token = getCookie("tokenINNOVA2");

    let ahora = new Date();

    let horaActual = ahora.getHours();
    let minutosActuales = ahora.getMinutes();

    let isValid = true;
    if (hastaV <= desdeV) {
      isValid = false;
    }

    let horaFormateada = hora.toString().padStart(2, "0");
    let minutosFormateados = minutos.toString().padStart(2, "0");

    if (
      hora < horaActual ||
      (hora === horaActual && minutos < minutosActuales)
    ) {
      isValid = false;
    }

    console.log("hora", hora, minutos);
    console.log("hora2", hora2, minutos2);

    console.log("horaActua", horaActual, minutosActuales);

    if (!isValid) {
      toast.error(
        "La hora programada debe ser mayor a la actual, además la hora final debe ser mayor a la inicial y la fecha",
        {
          closeButton: true,
        }
      );
    } else {
      this.setState({ isExecuting: true, errorLogin: false });
      var resp = await setReservaV2(
        "Visita",
        "Promoción Salud",
        "",
        "",
        token,
        selHora,
        this.state.fechaActual,
        this.state.id_consultorio,
        this.state.idPaciente
      );

      console.log("RESP", resp);
      if (resp.success) {
        await this.gethorasLibres();

        this.setState({
          ...this.state,
          modalConfirm9: false,
          errorLogin: false,
          isExecuting: false,
          carnet_identidad: "",
          carnet_identidad_seleccionado: "",
          checkPlanPatient: null,
          benefClinic: [],
          id_servicio: 0,
          noBreak: false,
        });

        socket.emit("chat_solicitud", {
          Cod_oficina: this.state.Cod_oficina,
          Cod_empresa: this.state.consultorioInfo.Cod_empresa,
          usuario: socket.id,
          paciente: "Visita",
          hora: selHora,
          cedula: "Visita",
        });

        if (this.state.rol === "Consultorio") {
          this.setState({ ...this.state, modalSucc: true });

          setTimeout(
            function () {
              this.setState({ ...this.state, modalSucc: false });
            }.bind(this),
            5000
          );
        }
      } else {
        toast.error(resp.message, {
          closeButton: true,
        });

        this.setState({
          ...this.state,
          modalConfirm9: false,
          id_servicio: 0,
          errorLogin: true,
          errorMessage: resp.message,
          isExecuting: false,
        });
      }
    }
  };

  setResetMensaje = () => {
    let minutos = this.state.minutos;
    //console.log("RESET", minutos)
    clearInterval(this.state.intervalId);

    var intervalId = setInterval(this.refreshActive, minutos * 60 * 1000);

    setTimeout(
      function () {
        this.setState({ active: 0 });
      }.bind(this),
      3000
    );

    this.setState({ intervalId: intervalId });
  };

  refreshActive = () => {
    let _active = this.state.active + 1;

    if (_active >= this.state.mensajes.length) {
      this.setState({ active: 0 });
    } else {
      this.setState({ active: _active });
    }
  };

  gethorasLibres = async (cedula) => {
    //console.log("gethorasLibres");
    const Cod_empresa = getCookie("empresaINNOVA2");
    let token = getCookie("tokenINNOVA2");
    if (this.state.usuario_rol !== "Monitor") {
      this.setState({ isExecuting: true });
    }
    let horas_libres = [];
    let date = new Date();
    let refrigerioActivo = false;
    let visitaActivo = false;
    let existeRefrigerio = false;
    let existeVisita = false;
    date.setHours(date.getHours()); //para modificar la hora actual

    //date = new Date(); //DEFINIR HORA
    //console.log("date", date);

    let minutes = date.getMinutes();

    let roundedMinutes = Math.ceil(minutes / 10) * 10;

    if (roundedMinutes === 60) {
      date.setHours(date.getHours() + 1);
      date.setMinutes(0);
    } else {
      date.setMinutes(roundedMinutes);
    }

    // Formatear la hora en formato HH:mm
    let formattedTime =
      date.getHours().toString().padStart(2, "0") +
      ":" +
      date.getMinutes().toString().padStart(2, "0");

    //  console.log("redondeado", formattedTime);

    let fechaStr = new Date().toLocaleDateString("es-es", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    let fechaActual =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1).toString().padStart(2, "00") +
      "-" +
      date.getDate().toString().padStart(2, "00");

    date.setDate(date.getDate() + 1);
    let fechaFin =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1).toString().padStart(2, "00") +
      "-" +
      date.getDate().toString().padStart(2, "00");

    //console.log("fechaActual", fechaActual);

    var _resp2 = await getDiasByIdConsultorioYServicio(
      Cod_empresa,
      fechaActual,
      fechaFin,
      1,
      this.state.rol === "Doctor" ? "NN" : "CONSULTORIO",
      this.state.id_servicio,
      this.state.carnet_identidad,
      0
    );

    if (_resp2.timeout) {
      toast.error("Error de conexión a la base de datos", {
        closeButton: true,
      });
    }
    //    console.log("_resp2", _resp2);
    var resp2 = {
      horas: [],
    };

    try {
      let horas = [];
      let noBreak = true;
      let noVisit = true;
      let noBreakVisit = true;
      for (let i in _resp2.dias[0].horas) {
        let hora = _resp2.dias[0].horas[i];

        if (
          hora.paciente === "Refrigerio del Doctor " &&
          //          hora.atendido === "N"
          hora.atendido === "E"
        ) {
          this.setState({
            ...this.state,
            lookRefrigerio: true,
            refrigerioActivoMon: true,
          });
          /*
          refrigerioActivo = true;
          let ahora = new Date();
          let horaActual = ahora.getHours();
          let minutosActuales = ahora.getMinutes();

          // Dividir la hora y los minutos de la horaString
          let [horaT, minutosT] = hora.id_hora.split(":");

          // Convertir a números
          horaT = parseInt(horaT, 10);
          minutosT = parseInt(minutosT, 10);

          if (
            horaActual < horaT ||
            (horaT === horaActual && minutosActuales < minutosT)
          ) {
            console.log("NO paso");
          } else {
            console.log("ya paso");

            this.setState({
              ...this.state,
              refrigerioActivoMon: true,
            });
          }*/
        }

        if (
          hora.paciente === "Refrigerio del Doctor " &&
          hora.atendido === "S"
        ) {
          this.setState({
            ...this.state,
            lookRefrigerio: true,
            refrigerioActivoMon: false,
          });
        }

        if (
          hora.paciente === "Refrigerio del Doctor " &&
          hora.atendido === "N"
        ) {
          existeRefrigerio = true;
          this.setState({
            ...this.state,
            lookRefrigerio: true,
          });
        }

        if (hora.cedula === "Refrigerio") {
          noBreak = false;
          if (hora.atendido === "E") {
            noBreakVisit = false;
          }
        }

        if (
          hora.paciente === "Promoción Salud " &&
          //hora.atendido === "N"
          hora.atendido === "E"
        ) {
          //console.log("visitaActivoMon");
          this.setState({
            ...this.state,
            visitaActivoMon: true,
            lookRef2: true,
          });
          /*
          visitaActivo = true;
          let ahora = new Date();
          let horaActual = ahora.getHours();
          let minutosActuales = ahora.getMinutes();

          // Dividir la hora y los minutos de la horaString
          let [horaT, minutosT] = hora.id_hora.split(":");

          // Convertir a números
          horaT = parseInt(horaT, 10);
          minutosT = parseInt(minutosT, 10);

          if (
            horaActual < horaT ||
            (horaT === horaActual && minutosActuales < minutosT)
          ) {
            console.log("NO paso VIS");
          } else {
            console.log("ya paso VIS ");

            this.setState({
              ...this.state,
              visitaActivoMon: true,
            });
          }
          */
        }

        if (hora.paciente === "Promoción Salud " && hora.atendido === "S") {
          this.setState({
            ...this.state,
            //lookVisita: true,
            visitaActivoMon: false,
          });
        }

        if (hora.cedula === "Visita") {
          //console.log("bloqueamos!")
          noVisit = false;
          if (hora.atendido === "E") {
            noBreakVisit = false;
          }
        }

        if (hora.paciente === "Promoción Salud " && hora.atendido === "N") {
          //   console.log(hora);
          existeVisita = true;
        }

        hora["hora_larga"] = hora.hora;
        hora["hora"] = hora.id_hora; //horaS;
        horas.push(hora);
      }

      this.setState({
        ...this.state,
        noBreak: noBreak,
        noVisit: noVisit,
        noBreakVisit: noBreakVisit,
      });

      resp2 = {
        horas_libres: horas,
      };
    } catch (e) {
      //console.log("no horas");
      resp2 = {
        horas_libres: [],
      };
    }

    if (resp2.horas_libres.length > 0) {
      horas_libres = resp2.horas_libres;
      let horaAct = parseInt(
        date.getHours().toString().padStart(2, "00") +
          "" +
          date.getMinutes().toString().padStart(2, "00")
      );

      //horaAct = 1045

      let posCurr;
      let posNext = -1;
      let succNext = false;

      // console.log("horaAct", horaAct);
      let firstN = true;
      for (let h in horas_libres) {
        let hora = horas_libres[h];

        if (
          hora.cedula === "NUEVO" &&
          hora.atendido === "E" &&
          hora.servicios !== "REGISTRADO" &&
          this.state.usuario_rol === "Doctor"
        ) {
          let _servicioBenef = hora.servicios.split("|");
          //console.log("hora", hora, _servicioBenef[0]);
          this.setState({
            ...this.state,
            modalConfirm14: true,
            id_hora_nuevo: hora.id,
            //servicioNuevoBenef: _servicioBenef[0],
          });

          checkPlanPatient(
            hora.datosExtra1.usuario_registro,
            this.state.id_servicio
          ).then((resp) => {
            console.log("r", resp);

            this.setState({
              ...this.state,
              servicios_nuevo: resp.data.Items,
              DocEntry: resp.data.Items[0].DocEntry,
            });
          });
          //console.log("resp",resp)
        }

        let _hora1 = parseInt(hora.hora_larga.substr(0, 5).replace(":", ""));

        if (firstN) {
          if (horaAct <= _hora1) {
            hora["now"] = true;
            firstN = false;
          }
        }

        if (hora.cedula && hora.cedula !== "S/D") {
          hora["free"] = false;
          //	console.log(hora)
          if (hora.atendido === "N") {
            hora["selected"] = true;
          } else if (hora.atendido === "E") {
            hora["current"] = true;

            // console.log("hora", hora);

            let data = hora;
            let _servicios = [];
            let servicios = [];
            try {
              _servicios = data.servicios.split(",");
              for (let s in _servicios) {
                let _id = _servicios[s].split("|");
                let id = _id[1];
                let prod = _id[0];
                let producto = prod;

                let pos = this.state.serviciosOrig.findIndex(
                  (item) => id === item.codServInnova.toString()
                );
                if (pos >= 0) {
                  let valor = {
                    codServInnova:
                      prod + "|" + this.state.serviciosOrig[pos].codServInnova,
                    descripcion_corta:
                      this.state.serviciosOrig[pos].descripcion_servicio,
                    descripcion_servicio:
                      "PLAN " +
                      producto +
                      ": " +
                      this.state.serviciosOrig[pos].descripcion_servicio,
                  };
                  let posV = 0;
                  for (let i in servicios) {
                    //console.log("comparando", servicios[i])
                    if (
                      servicios[i].codServInnova ===
                      prod + "|" + this.state.serviciosOrig[pos].codServInnova
                    ) {
                      posV++;
                    }
                  }
                  if (posV === 0) {
                    servicios.push(valor);
                  }
                }
              }
            } catch (e) {
              servicios = [];
            }

            this.setState({
              ...this.state,

              serviciosPacientePantalla: servicios,
              pacientePantalla: data.paciente,
              cedulaPantalla: data.cedula,
            });
          } else if (hora.atendido === "S") {
            hora["expired"] = true;
          }
        } else {
          //console.log("checking",  horaAct, _hora1 )
          hora["cedula"] = "";
          hora["paciente"] = "libre";
          hora["free"] = true;

          let fitrar = false;
          if (horaAct <= _hora1 && !succNext) {
            //	console.log("cumple 1")
            if (!hora.esReservada) {
              //		console.log("cumple 2")
              posNext = h;
              succNext = true;
            } else {
              hora["selected"] = true;
              fitrar = true;
            }
          }
          if (horaAct >= _hora1) {
            //            console.log("posCurr", posCurr);
            posCurr = h;
          }

          if (horaAct > _hora1) {
            //console.log("expired")
            hora["free"] = false;
            hora["expired"] = true;
          } else {
            if (!fitrar) {
              hora["free"] = true;
            }
          }

          if (hora.cedula === "S/D") {
            hora["cedula"] = "";
          }
        }
      }

      if (!posCurr) {
        for (let h in horas_libres) {
          let hora = horas_libres[h];

          if (!posCurr) {
            if (!hora.cedula || hora.cedula === "") {
              posCurr = h;
              //horas_libres[h]["current"] = true
              horas_libres[h]["free"] = true;
              horas_libres[h]["expired"] = false;
            }
          }
          if (posNext < 0) {
            let _hora1 = parseInt(
              hora.hora_larga.substr(0, 5).replace(":", "")
            );
            //	console.log("CH", _hora1, horaAct)
            if (!hora.cedula || hora.cedula === "") {
              if (horaAct > _hora1) {
                posNext = h;
              }
            }
          }
        }
      }

      if (posNext >= 0) {
        if (cedula) {
          horas_libres[posNext]["cedula"] = cedula;
        }

        /*				
								horas_libres[posNext]["next"] = true
								horas_libres[posNext]["free"] = false
								horas_libres[posNext]["expired"] = false
				*/

        let actual = formattedTime;
        let selected = horas_libres[posNext].hora;

        let actualDate = new Date();
        let selectedDate = new Date();

        // Establecer la hora y los minutos en cada objeto Date
        let actualParts = actual.split(":");
        actualDate.setHours(parseInt(actualParts[0], 10));
        actualDate.setMinutes(parseInt(actualParts[1], 10));

        let selectedParts = selected.split(":");
        selectedDate.setHours(parseInt(selectedParts[0], 10));
        selectedDate.setMinutes(parseInt(selectedParts[1], 10));

        let mover = false;
        if (this.state.usuario_rol === "Consultorio") {
          if (actualDate < selectedDate) {
            // Calcular la diferencia en minutos
            let difference = (selectedDate - actualDate) / (1000 * 60); // milisegundos a minutos

            if (posNext > 0) {
              let hora_ant = horas_libres[posNext - 1];
              if (hora_ant.estado === "libre") {
                mover = true;
              }
            }

            if (mover) {
              let hora = actualDate.getHours().toString().padStart(2, "0");
              let minutos = actualDate.getMinutes().toString().padStart(2, "0");
              let horaMinutos = hora + ":" + minutos;

              actualDate.setMinutes(actualDate.getMinutes() + 20);

              let horaNueva = actualDate.getHours().toString().padStart(2, "0");
              let minutosNuevos = actualDate
                .getMinutes()
                .toString()
                .padStart(2, "0");
              let horaMinutosNueva = horaNueva + ":" + minutosNuevos;

              let newHora = horaMinutos + " - " + horaMinutosNueva;

              // console.log("ajustanto hora", actualDate, newHora);
              horas_libres[posNext].hora_larga = newHora;
            }
          }
        }

        this.setState({
          ...this.state,
          hora: horas_libres[posNext].hora_larga,
          selHora: horas_libres[posNext].hora_larga,
        });

        this.setState({
          ...this.state,
          showModal: true,
        });
      } else {
        // console.log("lockReservas1", horas_libres, posNext);
        this.setState({ ...this.state, lockReservas: true, showModal: false });
      }

      if (posCurr === 0) {
        //horas_libres[0]["current"] = false
        //horas_libres[0]["free"] = true
      }

      //console.log(horas_libres, existeVisita);

      if (this.state.usuario_rol !== "Monitor") {
        this.setState({
          ...this.state,
          horas_libres: horas_libres,
          isExecuting: false,
          existeRefrigerio: existeRefrigerio,
          existeVisita: existeVisita,
          fechaActual: fechaActual,
          fechaStr: fechaStr,
        });
      } else {
        console.log("Notif");

        this.setState({
          ...this.state,
          horas_libres: horas_libres,
          //isExecuting: false,
          existeRefrigerio: existeRefrigerio,
          existeVisita: existeVisita,
          fechaActual: fechaActual,
          fechaStr: fechaStr,
        });

        this.removeEndedListener();

        setTimeout(
          function () {
            if (this.myRef?.current) {
              if (this.state.usuario_rol === "Monitor") {
                console.log("add listener");
                this.myRef.current.addEventListener("ended", this.handleEnded);
              }
            }
          }.bind(this),
          2500
        );
      }
    } else {
      this.setState({
        ...this.state,
        lockReservas: true,
        isExecuting: false,
      });
    }

    this.setState({
      ...this.state,
      refrigerioActivo: refrigerioActivo,
      visitaActivo: visitaActivo,
    });
  };

  removeEndedListener() {
    if (this.myRef.current) {
      console.log("clear listener");
      this.myRef.current.removeEventListener("ended", this.handleEnded);
    } else {
      console.log("no listener");
    }
  }

  handleEnded() {
    console.log("next video", this.myRef);
    this.myRef.current.setAttribute("src", vids[n % leng]);
    n++;
    let newval = n % leng;
  }

  //revisar???
  buscarCI = async () => {
    let isValid = true;

    if (this.state.carnet_identidad === "") {
      isValid = false;
      toast.error("Favor complete el campo Carnet de Identidad", {
        closeButton: true,
      });
    }

    if (isValid) {
      this.setState({ isExecuting: true, carnet_identidad_seleccionado: "" });
      var resp = await checkPlanPatient(
        this.state.carnet_identidad,
        this.state.id_servicio
      );

      if (resp.success || resp.Estado === "E") {
        const fecha = new Date();

        let servicios = [];

        for (let i in resp.data.Items) {
          let key = resp.data.Items[i];

          let _iniy = key.FechaInicio.substr(0, 4);
          let _inim = key.FechaInicio.substr(4, 2);
          let _inid = key.FechaInicio.substr(6, 2);

          let _finy = key.FechaFin.substr(0, 4);
          let _finm = key.FechaFin.substr(4, 2);
          let _find = key.FechaFin.substr(6, 2);

          let fecha_inicio =
            _iniy + "-" + _inim + "-" + _inid + "T04:00:00.000Z";
          let fecha_fin = _finy + "-" + _finm + "-" + _find + "T04:00:00.000Z";
          let validituNumberF = new Date(fecha_inicio);
          let validituNumberT = new Date(fecha_fin);

          //console.log(validituNumberF, validituNumberT, fecha);
          if (validituNumberF <= fecha && fecha <= validituNumberT) {
            for (let i in key.Prestaciones) {
              let servicio = key.Prestaciones[i];

              let pos = this.state.serviciosOrig.findIndex(
                (item) => item.codSAP === servicio.Codigo
              );

              if (pos >= 0) {
                let serv = this.state.serviciosOrig[pos];
                serv["id_product"] = key.Codigo;
                servicios.push(serv);
              }
            }
          }
        }

        this.setState({
          ...this.state,
          servicios: servicios,
          step1: true,
          //revisar???  carnet_identidad_seleccionado: this.state.carnet_identidad,
          isExecuting: false,
          checkPlanPatient: resp,
        });
      } else {
        this.setState({
          ...this.state,
          errorLogin: true,
          errorMessage: this.state.paciente_no_encontrado,
          isExecuting: false,
        });
      }
    }
  };

  buscarPaciente = async () => {
    let isValid = true;
    //console.log("buscarPaciente");
    if (this.state.carnet_identidad === "") {
      isValid = false;
      toast.error("Favor complete el campo Carnet de Identidad", {
        closeButton: true,
      });
    }
    /*
    if (this.state.id_servicio == 0) {
      toast.error("Favor seleccione el tipo de Servicio", {
        closeButton: true,
      });
      isValid = false;
    }
*/
    if (isValid) {
      this.setState({ isExecuting: true, nuevaCompra: false });
      let resp;
      if (this.state.checkPlanPatient) {
        resp = this.state.checkPlanPatient;
      } else {
        //checkPlanPatient
        resp = await checkPlanPatient(
          this.state.carnet_identidad,
          this.state.id_servicio
        );
        console.log("resp final", resp);

        if (resp.showDependiente) {
          this.setState({ showDependiente: true });
        } else {
          this.setState({ showDependiente: false });
        }

        let resp2 = await checkPlanPatientBenef(
          this.state.carnet_identidad,
          this.state.id_servicio
        );
        // console.log("resp2", resp2);

        if (resp2.success) {
          this.setState({ benefClinic: resp2.data });
        }
      }

      if (resp.success || resp.Estado === "E") {
        //let servicios = 0;
        let servicios = [];

        let fecha = new Date();

        let planes = [];
        //console.log("resp.data.Items", resp.data.Items);
        for (let i in resp.data.Items) {
          let key = resp.data.Items[i];
          //  console.log("check, ", key)

          let _iniy = key.FechaInicio.substr(0, 4);
          let _inim = key.FechaInicio.substr(4, 2);
          let _inid = key.FechaInicio.substr(6, 2);

          let _finy = key.FechaFin.substr(0, 4);
          let _finm = key.FechaFin.substr(4, 2);
          let _find = key.FechaFin.substr(6, 2);

          let fecha_inicio =
            _iniy + "-" + _inim + "-" + _inid + "T04:00:00.000Z";
          let fecha_fin = _finy + "-" + _finm + "-" + _find + "T04:00:00.000Z";
          let validituNumberF = new Date(fecha_inicio);
          let validituNumberT = new Date(fecha_fin);

          //   console.log(validituNumberF, validituNumberT, fecha);
          if (validituNumberF <= fecha && fecha <= validituNumberT) {
            planes.push({
              plan: key.Nombre,
              codigo: key.Codigo,
              fechaIni: _inid + "/" + _inim + "/" + _iniy,
              fechaFin: _find + "/" + _finm + "/" + _finy,
            });
            //console.log("key!!!", key);
            for (let i in key.Prestaciones) {
              let servicio = key.Prestaciones[i];

              let pos = -1;
              if (servicio.Hostgator) {
                pos = this.state.serviciosOrig.findIndex(
                  (item) => item.codServInnova === servicio.id_servicio
                );
              } else {
                pos = this.state.serviciosOrig.findIndex(
                  (item) => item.codSAP === servicio.Codigo
                );
              }
              if (pos >= 0) {
                let serv = this.state.serviciosOrig[pos];
                serv["id_product"] = key.Codigo;

                let newB = key.Beneficiarios ? key.Beneficiarios : [];

                const combinedArray = newB.concat(this.state.benefClinic);

				//const combinedArray = []; COMENTARIO VACIAR ARREGLO

                const uniqueArray = Array.from(
                  new Set(combinedArray.map((item) => JSON.stringify(item)))
                ).map((item) => JSON.parse(item));

                serv["Beneficiarios"] = uniqueArray;
                serv["tieneBenef"] = key.Beneficiarios ? true : false; //AQUI PONER EL CRITERIO
                servicios.push(serv);
              }
            }
          }
        }
        //        console.log("planes", planes);

        /*
        for (let i in resp.data.Items) {
          let plan = resp.data.Items[i];

          for (let s in plan.Prestaciones) {
            let p = plan.Prestaciones[s];

            if (p.Codigo === this.state.id_servicio) {
              let disp = p.CantidadPrestacion - p.CantidadUtilizada;

              servicios += disp;
            }
          }
        }

        if (resp.reservas) {
          servicios -= resp.reservas.length;
        }
        */

        // console.log("servicios", servicios, this.state.id_servicio);

        if (planes.length > 1) {
          //  console.log("tiene mas de un plan activo");

          this.setState({
            ...this.state,
            planes: planes,
            modalConfirm8: true,
            isExecuting: false,
            respState: resp,
            carnet_identidad_seleccionado: "",
          });
        } else {
          if (servicios.length > 0) {
            this.setState({
              ...this.state,
              carnet_identidad_seleccionado: this.state.carnet_identidad,
            });

            this.setCitaPaciente(resp, servicios);
          } else {
            this.setState({
              ...this.state,
              errorLogin: true,
              errorMessage:
                "Lo sentimos Ud. no tiene asociado este servicio dentro de ningun plan adquirido",
              isExecuting: false,
            });
          }
        }
      } else {
        this.setState({
          ...this.state,

          modalConfirm15: true,
          nuevaCompra: true,
          /*
          modalConfirm: false,
          id_servicio: 0,
          errorLogin: true,
          errorMessage: resp.message,
          */
          isExecuting: false,
        });

        /*
        this.setState({
          ...this.state,
          errorLogin: true,
          errorMessage: this.state.paciente_no_encontrado,
          isExecuting: false,
        });
        */
      }
    }
  };

  setCIFinal = (documento) => {
    console.log("SetCI", this.state, documento);

    let nombre, apellido;
    if (documento == this.state.carnet_identidad) {
      nombre = this.state.nombreT;
      apellido = this.state.apellidoT;
    } else if (documento == "NUEVO") {
      nombre = this.state.nombreT + " " + this.state.apellidoT;
      apellido = "(NUEVO BENEF)";
    } else {
      for (let i in this.state.Beneficiarios) {
        let benef = this.state.Beneficiarios[i];
        if (benef.NumDocumento == documento) {
          nombre = benef.Pnombre;
          apellido = benef.Papellido;
        }
      }
    }

    this.setState({
      ...this.state,
      carnet_identidad_seleccionado: documento,
      nombre: nombre,
      apellido: apellido,
    });
  };
  setPlanPaciente = async (index) => {
    let resp = this.state.respState;
    let servicios = [];
    for (let i in resp.data.Items) {
      let key = resp.data.Items[i];

      //          console.log(validituNumberF, validituNumberT, fecha);
      if (i == index) {
        for (let i in key.Prestaciones) {
          let servicio = key.Prestaciones[i];

          let pos = this.state.serviciosOrig.findIndex(
            (item) => item.codSAP === servicio.Codigo
          );

          if (pos >= 0) {
            let serv = this.state.serviciosOrig[pos];
            serv["id_product"] = key.Codigo;

            let newB = key.Beneficiarios ? key.Beneficiarios : [];
            let finB = newB.concat(this.state.benefClinic);

            serv["Beneficiarios"] = finB;

            serv["tieneBenef"] = key.Beneficiarios ? true : false; //AQUI PONER EL CRITERIO
            servicios.push(serv);
          }
        }
      }
    }

    if (servicios.length > 0) {
      this.setState({
        ...this.state,
        modalConfirm8: false,
        carnet_identidad_seleccionado: "",
      });

      this.setCitaPaciente(resp, servicios);
    } else {
      this.setState({
        ...this.state,
        errorLogin: true,
        errorMessage:
          "Lo sentimos Ud. no tiene asociado este servicio dentro de ningun plan adquirido",
        isExecuting: false,
      });
    }
  };

  setCitaPaciente = async (resp, servicios) => {
    let IdPaciente = resp.data.IdPaciente;

    await this.gethorasLibres();

    console.log("resp", servicios);

    let tieneBenef = false;
    let Beneficiarios = [];
    for (let i in servicios) {
      if (servicios[i].tieneBenef) {
        tieneBenef = true;
        Beneficiarios = servicios[i].Beneficiarios;
      }
    }

    this.setState({
      ...this.state,
      goRegister: true,
      //carnet_identidad_seleccionado:  carnet_identidad,
      tieneBenef: tieneBenef,
      Beneficiarios: Beneficiarios,
      isExecuting: false,
      IdPaciente: IdPaciente,
      userName:
        resp.data.Pnombre +
        " " +
        resp.data.Papellido +
        " " +
        resp.data.Sapellido,
      nombre: resp.data.Pnombre,
      apellido: resp.data.Papellido,

      nombreT: resp.data.Pnombre,
      apellidoT: resp.data.Papellido,

      plan: resp.data.Items[0]?.Nombre,
      consultorio: this.state.consultorioInfo.primer_nombre,
      doctor: this.state.consultorioInfo.segundo_nombre,
      modalConfirm: this.state.showModal,
      servicios: servicios,
    });
  };
  showMessage = async (mensaje, data) => {
    await this.gethorasLibres();
    if (
      (mensaje.indexOf("Refrigerio") >= 0 || mensaje.indexOf("Visita") >= 0) &&
      this.state.rol === "Doctor"
    ) {
      console.log("refrigerio/visita doctor");
    } else {
      //  console.log(this.state.horas_libres, mensaje, data.servicios);

      let _servicios = [];

      let servicios = [];
      try {
        _servicios = data.servicios.split(",");
        for (let s in _servicios) {
          let _id = _servicios[s].split("|");
          let id = _id[1];
          let prod = _id[0];
          let producto = prod;

          let pos = this.state.serviciosOrig.findIndex(
            (item) => id === item.codServInnova.toString()
          );
          if (pos >= 0) {
            let valor = {
              codServInnova:
                prod + "|" + this.state.serviciosOrig[pos].codServInnova,
              descripcion_corta:
                this.state.serviciosOrig[pos].descripcion_servicio,

              descripcion_servicio:
                "PLAN " +
                producto +
                ": " +
                this.state.serviciosOrig[pos].descripcion_servicio,
            };

            let posV = 0;
            for (let i in servicios) {
              // console.log("comparando", servicios[i])
              if (
                servicios[i].codServInnova ===
                prod + "|" + this.state.serviciosOrig[pos].codServInnova
              ) {
                posV++;
              }
            }
            if (posV === 0) {
              servicios.push(valor);
            }
          }
        }
      } catch (e) {
        servicios = this.state.serviciosOrig;
      }

      let pos = this.state.horas_libres.findIndex(
        (item) => item.atendido === "E"
      );

      this.setState({
        mensajeNew: mensaje,
        modalConfirm2: true,
        pacienteDoc: data.paciente,
        cedulaDoc: data.cedula,
        serviciosPacienteNuevo: servicios,
      });

      setTimeout(
        function () {
          this.setState({ ...this.state, modalConfirm2: false });
        }.bind(this),
        10000
      );
    }
  };

  showCalificacion = async (data) => {
    console.log("showCalificacion", data);
    this.setState({
      showCalificacionButton: true,
      dataCalificacion: data,
    });
    setTimeout(
      function () {
        this.setState({ ...this.state, showCalificacionButton: false });
      }.bind(this),
      1000 * 60 /*120*/
    );
  };

  sendMessage = async (cedula, paciente, id_hora) => {
    if (this.state.rol === "Doctor") {
      let pos = this.state.horas_libres.findIndex(
        (item) => item.atendido === "E"
      );
      if (pos < 0) {
        let pos2 = this.state.horas_libres.findIndex(
          (item) => item.id === id_hora
        );
        let data = this.state.horas_libres[pos2];
        let _servicios = [];
        let servicios = [];
        try {
          _servicios = data.servicios.split(",");
          for (let s in _servicios) {
            let _id = _servicios[s].split("|");
            let id = _id[1];
            let prod = _id[0];
            let producto = prod;

            let pos = this.state.serviciosOrig.findIndex(
              (item) => id === item.codServInnova.toString()
            );
            if (pos >= 0) {
              let valor = {
                codServInnova:
                  prod + "|" + this.state.serviciosOrig[pos].codServInnova,
                descripcion_corta:
                  this.state.serviciosOrig[pos].descripcion_servicio,

                descripcion_servicio:
                  "PLAN " +
                  producto +
                  ": " +
                  this.state.serviciosOrig[pos].descripcion_servicio,
              };
              let posV = 0;
              for (let i in servicios) {
                //console.log("comparando", servicios[i])
                if (
                  servicios[i].codServInnova ===
                  prod + "|" + this.state.serviciosOrig[pos].codServInnova
                ) {
                  posV++;
                }
              }
              if (posV === 0) {
                servicios.push(valor);
              }
            }
          }
        } catch (e) {
          servicios = [];
        }

        this.setState({
          ...this.state,
          custommessage: "",
          serviciosPacientePantalla: servicios,
          pacientePantalla: paciente,
          cedulaPantalla: cedula,
          reeloadmessage: false,
          id_hora_doctor: id_hora,
        });
        setTimeout(
          function () {
            this.setState({
              ...this.state,
              reeloadmessage: false,
              custommessage:
                "Paciente " + paciente + " (CI:" + cedula + ") pase por favor",
            });
          }.bind(this),
          100
        );
      } else {
        this.setState({
          ...this.state,
          /*
          serviciosPacientePantalla: [],
          pacientePantalla: "",
          cedulaPantalla: "",*/
        });

        toast.error(
          "Debe cerrar la atencion en curso del paciente: " +
            this.state.horas_libres[pos].paciente,
          { closeButton: true }
        );
      }
    }
  };

  updateMessage = async () => {
    //console.log("upd hace lo q tiene q hacer")
    let token = getCookie("tokenINNOVA2");
    var resp = await setAtencion(token, this.state.id_hora_doctor);

    let id_hora = this.state.id_hora_doctor;
    const horas_libres = this.state.horas_libres;
    let pos = this.state.horas_libres.findIndex((item) => id_hora === item.id);

    horas_libres[pos]["selected"] = false;
    horas_libres[pos]["current"] = true;

    if (resp.success) {
      this.setState({
        ...this.state,
        custommessage: "",
        reeloadmessage: false,
        id_hora_doctor: 0,
        horas_libres: horas_libres,
      });
    } else {
      this.setState({
        ...this.state,
        isExecuting: false,
      });
      toast.error("Error registrando paciente en curso", { closeButton: true });
    }
  };

  buscarDatosNuevoPaciente = async (id_hora) => {
    let pos = this.state.horas_libres.findIndex((item) => id_hora === item.id);
    let token = getCookie("tokenINNOVA2");
    this.setState({
      ...this.state,
      isExecuting: true,
    });

    try {
      console.log(this.state.horas_libres[pos]);
      let resp = await checkPlanPatientSAP(
        this.state.horas_libres[pos].cedula,
        0
      );
      console.log("setActualizaAtencion", resp);
      let notifErr = false;
      if (resp.success) {
        if (resp.data.estado != "X") {
          let paciente = resp.data.Nombres + " " + resp.data.Papellido;
          console.log("paciente", paciente);
          let resp2 = await setActualizaAtencion(
            token,
            this.state.horas_libres[pos].id,
            "PPCE0071|280",
            paciente
          );

          console.log("setActualizaAtencion", resp2);
          if (resp2.success) {
            await this.gethorasLibres();
          } else {
           // notifErr = true;
          }
        } else {
         // notifErr = true;
        }
      } else {
       // notifErr = true;
      }
      if (notifErr) {
        if (this.state.notifErr) {
          console.log("bypass");

          let resp2 = await setActualizaAtencion(
            token,
            this.state.horas_libres[pos].id,
            "PPCE0071|280",
            "NO SE PUDO RECUPERAR"
          );

          console.log("setActualizaAtencion", resp2);
          if (resp2.success) {
            await this.gethorasLibres();
          } else {
            notifErr = true;
          }
        } else {
          /*
          this.setState({
            ...this.state,
            notifErr: true,
          });
          */
        }

        toast.error(
          "Favor asegúrese de haber efectuado la venta del plan al nuevo cliente e intente nuevamente",
          { closeButton: true }
        );
      }
    } catch (e) {
      console.log("e", e);
    }

    this.setState({
      ...this.state,
      isExecuting: false,
    });
  };

  cerrarConsulta = async (id_hora) => {
    let pos = this.state.horas_libres.findIndex((item) => id_hora === item.id);

    let _servicios = [];
    let servicios = [];
    let id_servicio = "";
    try {
      _servicios = this.state.horas_libres[pos].servicios.split(",");

      if (this.state.horas_libres[pos].cedula === "NUEVO") {
        this.setState({
          showNewPatient: true,
        });
      } else {
        this.setState({
          showNewPatient: false,
        });
      }
      for (let s in _servicios) {
        let _id = _servicios[s].split("|");
        let id = _id[1];
        let prod = _id[0];
        let producto = prod;

        let pos = this.state.serviciosOrig.findIndex(
          (item) => id === item.codServInnova.toString()
        );
        if (pos >= 0) {
          if (id_servicio === "") {
            id_servicio =
              prod + "|" + this.state.serviciosOrig[pos].codServInnova;
          }
          let valor = {
            codServInnova:
              prod + "|" + this.state.serviciosOrig[pos].codServInnova,
            descripcion_corta:
              this.state.serviciosOrig[pos].descripcion_servicio,

            descripcion_servicio:
              "PLAN " +
              producto +
              ": " +
              this.state.serviciosOrig[pos].descripcion_servicio,
          };

          let posV = 0;
          for (let i in servicios) {
            //console.log("comparando", servicios[i])
            if (
              servicios[i].codServInnova ===
              prod + "|" + this.state.serviciosOrig[pos].codServInnova
            ) {
              posV++;
            }
          }
          if (posV === 0) {
            servicios.push(valor);
          }
        }
      }
    } catch (e) {
      servicios = this.state.serviciosOrig;
      id_servicio = "|" + this.state.serviciosOrig[0].codServInnova;
    }

    this.setState({
      modalConfirm3: true,
      servicios: servicios,
      idHoraEnd: id_hora,
      id_servicio: id_servicio,
    });
  };

  setCalificacion = async (calificacion) => {
    let token = getCookie("tokenINNOVA2");
    let data = this.state.dataCalificacion;

    data["calificacion"] = calificacion;

    var resp = await setCalificacion(data, token);
    console.log("r", resp);

    this.setState({
      modalConfirm7: false,
      showCalificacionButton: false,
      dataCalificacion: {},
    });

    toast.success("Gracias por su gentil colaboración", { closeButton: true });
  };

  guardarPaciente = async () => {
    let validForm = true;
    var formDataPatient = {};
    if (validForm) {
      //console.log(this.state);

      var invalids = {
        benef_cedula: false,
        benef_primer_nombre: false,
        benef_apellido_paterno: false,
        benef_phone: false,
        benef_email: false,
      };

      let stringsToValid = [
        { field: "benef_apellido_paterno", label: "Apellido Paterno" },
        { field: "benef_primer_nombre", label: "Primer nombre" },
      ];

      let DocEntry = this.state.DocEntry;
      //console.log("DocEntry",DocEntry,this.state.servicios_nuevo)
      let posDE = this.state.servicios_nuevo.findIndex(
        (item) => DocEntry == item.DocEntry
      );

      let ItemCode = this.state.servicios_nuevo[posDE].Codigo;
      formDataPatient = {
        DocEntry: this.state.DocEntry,
        ItemCode: ItemCode,

        //servicioNuevoBenef: this.state.servicioNuevoBenef,
        primer_nombre: this.state.benef_primer_nombre,
        segundo_nombre: this.state.benef_segundo_nombre,
        apellido_paterno: this.state.benef_apellido_paterno,
        apellido_materno: this.state.benef_apellido_materno,
        cedula: this.state.benef_cedula,

        expedicion: this.state.benef_expedicion,
        extension: this.state.benef_extension,

        parentesco: this.state.benef_parentesco,
        phone: this.state.benef_phone,
        email: this.state.benef_email,
        genero: this.state.benef_radioGenero,
        fecha_naci:
          this.state.benef_year +
          "-" +
          this.state.benef_month +
          "-" +
          this.state.benef_day,
      };
      for (let i in stringsToValid) {
        if (this.state[stringsToValid[i].field] === "") {
          invalids[stringsToValid[i].field] = true;
          toast.warning("Debe completar el campo " + stringsToValid[i].label, {
            closeButton: true,
          });
          validForm = false;
        }
      }

      if (
        isNaN(this.state.benef_cedula) ||
        this.state.benef_cedula.length < 5
      ) {
        invalids["benef_cedula"] = true;
        toast.warning("Debe colocar un cédula válida", {
          closeButton: true,
        });
        validForm = false;
      }

      if (
        isNaN(this.state.benef_phone) ||
        this.state.benef_phone.length !== 8
      ) {
        invalids["benef_phone"] = true;
        toast.warning("Debe colocar un télefono válido", {
          closeButton: true,
        });
        validForm = false;
      } else {
        if (
          this.state.benef_phone < 60000000 ||
          this.state.benef_phone > 80000000
        ) {
          invalids["benef_phone"] = true;
          toast.warning("Debe colocar un télefono válido", {
            closeButton: true,
          });
          validForm = false;
        }
      }

      if (this.state.benef_email.length > 0) {
        var emailRegex =
          /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
        if (!emailRegex.test(this.state.benef_email)) {
          invalids["benef_email"] = true;
          toast.warning("Debe colocar un email válido", {
            closeButton: true,
          });
          validForm = false;
        }
      }

      setTimeout(
        function () {
          this.setState({
            invalids: invalids,
          });
        }.bind(this),
        50
      );
    }

    if (!validForm) {
    } else {
      console.log("formDataPatient", formDataPatient);
      let token = getCookie("tokenINNOVA2");
      let id_hora = this.state.id_hora_nuevo;
      this.setState({ ...this.state, isExecuting: true });
      var resp = await guardarPaciente(token, formDataPatient, id_hora);

      //console.log(resp)
      if (resp.success) {
        this.setState({
          ...this.state,
          modalConfirm14: false,
        });
        await this.gethorasLibres();
        this.setState({
          ...this.state,
          DocEntry: "",
          //servicioNuevoBenef: "",
          benef_primer_nombre: "",
          benef_segundo_nombre: "",
          benef_apellido_paterno: "",
          benef_apellido_materno: "",
          benef_cedula: "",
          benef_expedicion: "",
          benef_extension: "",
          benef_parentesco: "ESPOSA",
          benef_phone: "",
          benef_email: "",
          benef_radioGenero: 1,
          benef_year: "2000",
          benef_month: "01",
          benef_day: "01",
        });
      } else {
        this.setState({
          ...this.state,
          isExecuting: false,
        });
        toast.error(
          "Error cerrando consulta, refresque la ventana e intente nuevamente",
          { closeButton: true }
        );
      }
    }
  };

  setFinAtencion = async () => {
    let validForm = true;

    console.log("showNewPatient", this.state.showNewPatient);
    var formDataPatient = {};
    if (this.state.showNewPatient) {
      console.log(this.state);

      var invalids = {
        benef_cedula: false,
        benef_primer_nombre: false,
        benef_apellido_paterno: false,
        benef_phone: false,
        benef_email: false,
      };

      let stringsToValid = [
        { field: "benef_apellido_paterno", label: "Apellido Paterno" },

        { field: "benef_primer_nombre", label: "Primer nombre" },
      ];

      formDataPatient = {
        primer_nombre: this.state.benef_primer_nombre,
        segundo_nombre: this.state.benef_segundo_nombre,
        apellido_paterno: this.state.benef_apellido_paterno,
        apellido_materno: this.state.benef_apellido_materno,
        cedula: this.state.benef_cedula,

        expedicion: this.state.benef_expedicion,
        extension: this.state.benef_extension,

        parentesco: this.state.benef_parentesco,
        phone: this.state.benef_phone,
        email: this.state.benef_email,
        genero: this.state.benef_radioGenero,
        fecha_naci:
          this.state.benef_year +
          "-" +
          this.state.benef_month +
          "-" +
          this.state.benef_day,
      };
      for (let i in stringsToValid) {
        if (this.state[stringsToValid[i].field] === "") {
          invalids[stringsToValid[i].field] = true;
          toast.warning("Debe completar el campo " + stringsToValid[i].label, {
            closeButton: true,
          });
          validForm = false;
        }
      }

      if (
        isNaN(this.state.benef_cedula) ||
        this.state.benef_cedula.length < 5
      ) {
        invalids["benef_cedula"] = true;
        toast.warning("Debe colocar un cédula válida", {
          closeButton: true,
        });
        validForm = false;
      }

      if (
        isNaN(this.state.benef_phone) ||
        this.state.benef_phone.length !== 8
      ) {
        invalids["benef_phone"] = true;
        toast.warning("Debe colocar un télefono válido", {
          closeButton: true,
        });
        validForm = false;
      } else {
        if (
          this.state.benef_phone < 60000000 ||
          this.state.benef_phone > 80000000
        ) {
          invalids["benef_phone"] = true;
          toast.warning("Debe colocar un télefono válido", {
            closeButton: true,
          });
          validForm = false;
        }
      }

      if (this.state.benef_email.length > 0) {
        var emailRegex =
          /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
        if (!emailRegex.test(this.state.benef_email)) {
          invalids["benef_email"] = true;
          toast.warning("Debe colocar un email válido", {
            closeButton: true,
          });
          validForm = false;
        }
      }

      setTimeout(
        function () {
          this.setState({
            invalids: invalids,
          });
        }.bind(this),
        50
      );
    }
    console.log("formDataPatient", formDataPatient, invalids);
    if (!validForm) {
    } else {
      let token = getCookie("tokenINNOVA2");

      let id_plan;
      let id_servicio;
      try {
        if (this.state.id_servicio != "") {
          let datos = this.state.id_servicio.split("|");
          id_plan = datos[0];
          id_servicio = datos[1];
        }
      } catch (e) {
        id_plan = "0";
        id_servicio = "0";
      }
      this.setState({ ...this.state, isExecuting: true });
      var resp = {};

      resp = await setFinAtencion(
        token,
        this.state.idHoraEnd,
        id_plan,
        id_servicio,
        formDataPatient
      );

      const horas_libres = this.state.horas_libres;
      let pos = this.state.horas_libres.findIndex(
        (item) => this.state.idHoraEnd === item.id
      );

      this.setState({
        ...this.state,
        isExecuting: false,
      });
      if (resp.success) {
        this.setState({
          ...this.state,

          benef_primer_nombre: "",
          benef_segundo_nombre: "",
          benef_apellido_paterno: "",
          benef_apellido_materno: "",
          benef_cedula: "",
          benef_expedicion: "",
          benef_extension: "",
          benef_parentesco: "ESPOSA",
          benef_phone: "",
          benef_email: "",
          benef_radioGenero: 1,
          benef_year: "2000",
          benef_month: "01",
          benef_day: "01",
        });

        horas_libres[pos]["current"] = false;
        horas_libres[pos]["expired"] = true;
        horas_libres[pos]["atendido"] = "S";
        this.setState({ ...this.state, horas_libres: horas_libres });

        //aqui aviso

        let idS = this.state.id_servicio;
        let posS = this.state.servicios.findIndex(
          (item) => idS === item.codServInnova
        );

        let servicio = this.state.servicios[posS];

        //console.log("state", this.state);
        let datosPaciente = {
          cedulaPantalla: this.state.cedulaPantalla,
          pacientePantalla: this.state.pacientePantalla,
          idHoraEnd: this.state.idHoraEnd,
          id_plan: id_plan,
          servicio: servicio.descripcion_corta,
        };
        console.log("chat_message: Paciente atendido", {
          Cod_oficina: this.state.Cod_oficina,
          usuario: socket.id,
          mensaje: "Paciente atendido",
          updateTable2: true,
          updateTable3: true,
          datosPaciente: datosPaciente,
        });
        socket.emit("chat_message", {
          Cod_oficina: this.state.Cod_oficina,
          usuario: socket.id,
          mensaje: "Paciente atendido",
          updateTable2: true,
          updateTable3: true,
          datosPaciente: datosPaciente,
        });
        this.setState({
          modalConfirm2: false,
          modalConfirm3: false,

          serviciosPacientePantalla: [],
          pacientePantalla: "",
          cedulaPantalla: "",
        });
      } else {
        toast.error(
          "Error cerrando consulta, refresque la ventana e intente nuevamente",
          { closeButton: true }
        );
      }
    }
  };

  setFinalizarRefrigerio = async () => {
    let token = getCookie("tokenINNOVA2");

    const horas_libres = this.state.horas_libres;
    let pos = this.state.horas_libres.findIndex(
      (item) => item.cedula === "Refrigerio"
    );

    let idHoraEnd = horas_libres[pos].id;
    var resp = await setFinAtencion(token, idHoraEnd, null, null);

    if (resp.success) {
      horas_libres[pos]["current"] = false;
      horas_libres[pos]["expired"] = true;
      horas_libres[pos]["atendido"] = "S";
      this.setState({ ...this.state, horas_libres: horas_libres });

      //aqui aviso

      socket.emit("chat_message", {
        Cod_oficina: this.state.Cod_oficina,
        usuario: socket.id,
        mensaje: "Refrigerio finalizado",
        updateTable2: true,
      });
      this.setState({
        modalConfirm2: false,
        modalConfirm3: false,
        modalConfirm5: false,

        serviciosPacientePantalla: [],
        pacientePantalla: "",
        cedulaPantalla: "",
      });
    } else {
      toast.error(
        "Error cerrando consulta, refresque la ventana e intente nuevamente",
        { closeButton: true }
      );
    }
  };

  setFinalizarVisita = async () => {
    let token = getCookie("tokenINNOVA2");

    const horas_libres = this.state.horas_libres;
    let idVis = this.state.idVis;
    let pos = this.state.horas_libres.findIndex((item) => item.id === idVis);

    console.log("ts", this.state, pos, this.state.horas_libres[pos]);
    let idHoraEnd = horas_libres[pos].id;
    var resp = await setFinAtencion(token, idHoraEnd, null, null);

    if (resp.success) {
      horas_libres[pos]["current"] = false;
      horas_libres[pos]["expired"] = true;
      horas_libres[pos]["atendido"] = "S";
      this.setState({ ...this.state, horas_libres: horas_libres });

      //aqui aviso

      socket.emit("chat_message", {
        Cod_oficina: this.state.Cod_oficina,
        usuario: socket.id,
        mensaje: "Promoción Salud finalizada",
        updateTable2: true,
      });
      this.setState({
        modalConfirm2: false,
        modalConfirm3: false,
        modalConfirm5: false,

        modalConfirm10: false,
        modalConfirm11: false,
        idVis: 0,
        serviciosPacientePantalla: [],
        pacientePantalla: "",
        cedulaPantalla: "",
      });
    } else {
      toast.error(
        "Error cerrando consulta, refresque la ventana e intente nuevamente",
        { closeButton: true }
      );
    }
  };

  eliminarRefrigerio = async () => {
    let token = getCookie("tokenINNOVA2");
    let id_hora;

    let pos = this.state.horas_libres.findIndex(
      (item) => "Refrigerio" === item.cedula
    );
    id_hora = this.state.horas_libres[pos].id;

    console.log("del", this.state.horas_libres[pos]);

    this.setState({
      isExecuting: true,
    });

    var resp = await eliminarRefrigerio(token, id_hora);

    const horas_libres = this.state.horas_libres;

    if (resp.success) {
      //    horas_libres[pos]["current"] = false;
      //   horas_libres[pos]["expired"] = false;

      horas_libres[pos]["esReservada"] = false;

      horas_libres[pos]["estado"] = "libre";
      horas_libres[pos]["free"] = true;
      horas_libres[pos]["paciente"] = "libre";
      horas_libres[pos]["atendido"] = null;

      horas_libres[pos]["cedula"] = "";
      console.log("existeRefrigerio false");
      this.setState({
        ...this.state,
        horas_libres: horas_libres,
        noBreak: true,
        modalConfirm6: false,
        isExecuting: false,
        refrigerioActivoMon: false,
        refrigerioActivo: false,
        existeRefrigerio: false,
        lookRefrigerio: false,
      });

      socket.emit("chat_message", {
        Cod_oficina: this.state.Cod_oficina,
        usuario: socket.id,
        mensaje: "",
        updateTable2: true,
      });
    } else {
      this.setState({
        isExecuting: false,
      });
      toast.error(
        "Error eliminando refrigerio, refresque la ventana e intente nuevamente",
        { closeButton: true }
      );
    }
  };

  iniciarRefrigerio = async () => {
    console.log("event", this.state.idRef);
    let token = getCookie("tokenINNOVA2");
    this.setState({
      isExecuting: true,
    });

    var resp = await setAtencion(token, this.state.idRef);
    console.log(resp);

    let id_hora = this.state.idRef;
    const horas_libres = this.state.horas_libres;
    let pos = this.state.horas_libres.findIndex((item) => id_hora === item.id);

    horas_libres[pos]["selected"] = false;
    horas_libres[pos]["current"] = true;

    if (resp.success) {
      socket.emit("chat_message", {
        Cod_oficina: this.state.Cod_oficina,
        usuario: socket.id,
        mensaje: "El doctor esta en Refrigerio",
        updateTable2: true,
      });

      this.setState({
        ...this.state,
        custommessage: "",
        reeloadmessage: false,
        isExecuting: false,
        idRef: 0,
        modalConfirm12: false,
        horas_libres: horas_libres,
      });
    } else {
      this.setState({
        ...this.state,
        isExecuting: false,
      });
      toast.error("Error registrando información", { closeButton: true });
    }
  };

  iniciarVisita = async () => {
    console.log("event", this.state.idVis);
    let token = getCookie("tokenINNOVA2");
    this.setState({
      isExecuting: true,
    });

    var resp = await setAtencion(token, this.state.idVis);
    console.log(resp);

    let id_hora = this.state.idVis;
    const horas_libres = this.state.horas_libres;
    let pos = this.state.horas_libres.findIndex((item) => id_hora === item.id);

    horas_libres[pos]["selected"] = false;
    horas_libres[pos]["current"] = true;

    if (resp.success) {
      socket.emit("chat_message", {
        Cod_oficina: this.state.Cod_oficina,
        usuario: socket.id,
        mensaje: "El doctor esta en Promoción Salud",
        updateTable2: true,
      });

      this.setState({
        ...this.state,
        custommessage: "",
        reeloadmessage: false,
        isExecuting: false,
        idVis: 0,
        modalConfirm13: false,
        horas_libres: horas_libres,
      });
    } else {
      this.setState({
        ...this.state,
        isExecuting: false,
      });
      toast.error("Error registrando información", { closeButton: true });
    }
  };

  eliminarVisita = async () => {
    let token = getCookie("tokenINNOVA2");
    let id_hora;

    let pos = this.state.horas_libres.findIndex(
      (item) => "Visita" === item.cedula
    );
    id_hora = this.state.horas_libres[pos].id;

    console.log("del", this.state, this.state.horas_libres[pos]);

    this.setState({
      isExecuting: true,
    });

    var resp = await eliminarRefrigerio(token, id_hora);

    const horas_libres = this.state.horas_libres;

    if (resp.success) {
      //    horas_libres[pos]["current"] = false;
      //   horas_libres[pos]["expired"] = false;

      horas_libres[pos]["esReservada"] = false;

      horas_libres[pos]["estado"] = "libre";
      horas_libres[pos]["free"] = true;
      horas_libres[pos]["paciente"] = "libre";
      horas_libres[pos]["atendido"] = null;

      horas_libres[pos]["cedula"] = "";

      this.setState({
        ...this.state,
        horas_libres: horas_libres,
        noBreak: true,
        modalConfirm6: false,

        modalConfirm10: false,
        modalConfirm11: false,

        isExecuting: false,
        visitaActivoMon: false,
        visitaActivo: false,
      });

      socket.emit("chat_message", {
        Cod_oficina: this.state.Cod_oficina,
        usuario: socket.id,
        mensaje: "",
        updateTable2: true,
      });
    } else {
      this.setState({
        isExecuting: false,
        modalConfirm11: false,
      });
      toast.error(
        "Error eliminando Promoción Salud, refresque la ventana e intente nuevamente",
        { closeButton: true }
      );
    }
  };

  clearCustommessage = () => {
    this.setState({ ...this.state, custommessage: "", reeloadmessage: false });
  };
  enviarMensaje2 = async () => {
    //console.log("enviando!")
    let mensaje = this.state.mensajeNew;
    let Cod_oficina = this.state.Cod_oficina;
    let pacienteDoc = this.state.pacienteDoc;
    socket.emit("chat_message", {
      Cod_oficina: Cod_oficina,
      usuario: socket.id,
      mensaje: "El paciente: " + pacienteDoc + " puede pasar",
    });
    this.setState({
      modalConfirm2: false,
    });
  };

  toggleConfirm = () => {
    this.setState({
      modalConfirm: !this.state.modalConfirm,
    });
  };

  toggleConfirm3 = () => {
    console.log("this", this.state);
    this.setState({
      modalConfirm3: !this.state.modalConfirm3,
    });
  };

  toggleConfirm2 = () => {
    this.setState({
      modalConfirm2: !this.state.modalConfirm2,
    });
  };
  toggleConfirm5 = () => {
    this.setState({
      modalConfirm5: !this.state.modalConfirm5,
    });
  };
  toggleConfirm12 = () => {
    this.setState({
      modalConfirm12: !this.state.modalConfirm12,
    });
  };

  toggleConfirm13 = () => {
    this.setState({
      modalConfirm13: !this.state.modalConfirm13,
    });
  };
  toggleConfirm14 = () => {
    this.setState({
      modalConfirm14: !this.state.modalConfirm14,
    });
  };

  toggleConfirm15 = () => {
    this.setState({
      modalConfirm15: !this.state.modalConfirm15,
    });
  };

  toggleConfirm6 = () => {
    this.setState({
      modalConfirm6: !this.state.modalConfirm6,
    });
  };

  toggleConfirm9 = () => {
    this.setState({
      modalConfirm9: !this.state.modalConfirm9,
    });
  };
  toggleConfirm10 = () => {
    this.setState({
      modalConfirm10: !this.state.modalConfirm10,
    });
  };
  toggleConfirm11 = () => {
    this.setState({
      modalConfirm11: !this.state.modalConfirm11,
    });
  };

  toggleConfirm7 = () => {
    this.setState({
      modalConfirm7: !this.state.modalConfirm7,
    });
  };

  toggleConfirm8 = () => {
    this.setState({
      modalConfirm8: !this.state.modalConfirm8,
    });
  };

  toggleConfirm4 = () => {
    this.setState({
      modalConfirm4: !this.state.modalConfirm4,
    });
  };

  setHora = async (hora) => {
    //console.log("setHora",hora)
    this.setState({ selHora: hora });
  };

  confirmarHora = async (hora) => {
    this.setState({ modalR: false, modalConfirm: true });
  };

  cancelHora = async (hora) => {
    //console.log("cancelHora")
    this.setState({ modalR: false, showScreen: true });
  };

  changeHandler = async (event) => {
    if (event.target.name === "carnet_identidad") {
      this.setState({
        ...this.state,
        [event.target.name]: event.target.value.trim(),
      });
    } else {
      this.setState({ ...this.state, [event.target.name]: event.target.value });
    }

    if (event.key === "Enter" && !this.state.lockReservas) {
      this.buscarCI(event);
    }
  };

  changeHandler_B = async (event) => {
    //    console.log("datos", event.target.name, event.target.value);
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  };

  toggleR = (event) => {
    this.setState({
      ["modalR"]: !this.state["modalR"],
    });
  };

  render() {
    return (
      <>
        <div
          style={{
            transition: "ease-in all .5s",
          }}
          className={
            this.state.rol === "Consultorio"
              ? "main-consultorio"
              : "main-default"
          }
        >
          <ToastContainer
            hideProgressBar={true}
            newestOnTop={false}
            position={"bottom-right"}
            autoClose={3000}
          />

          {this.state.modalConfirm12 && (
            <MDBModal
              isOpen={this.state.modalConfirm12}
              centered
              toggle={this.toggleConfirm12}
            >
              <MDBModalHeader>
                <h3>Iniciar Refrigerio</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 10 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      Confirma que desea Iniciar el refrigerio
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm12}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.iniciarRefrigerio}
                >
                  <span className="ml-2"> Iniciar</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm13 && (
            <MDBModal
              isOpen={this.state.modalConfirm13}
              centered
              toggle={this.toggleConfirm13}
            >
              <MDBModalHeader>
                <h3>Iniciar Promoción Salud</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 10 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      Confirma que desea Iniciar la Promoción Salud
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm13}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.iniciarVisita}
                >
                  <span className="ml-2"> Iniciar</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm5 && (
            <MDBModal
              isOpen={this.state.modalConfirm5}
              centered
              toggle={this.toggleConfirm5}
            >
              <MDBModalHeader>
                <h3>Finalizar refrigerio</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 10 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      Confirma que desea finalizar el refrigerio
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm5}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.setFinalizarRefrigerio}
                >
                  <span className="ml-2"> Finalizar</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm6 && (
            <MDBModal
              isOpen={this.state.modalConfirm6}
              centered
              toggle={this.toggleConfirm6}
            >
              <MDBModalHeader>
                <h3>Cancelar refrigerio</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 10 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      Confirma que cancelar el refrigerio programado?
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm6}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.eliminarRefrigerio}
                >
                  <span className="ml-2"> Cancelar Refrigerio</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm10 && (
            <MDBModal
              isOpen={this.state.modalConfirm10}
              centered
              toggle={this.toggleConfirm10}
            >
              <MDBModalHeader>
                <h3>Finalizar Promoción Salud</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 10 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      Confirma que desea finalizar la Promoción Salud
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm10}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.setFinalizarVisita}
                >
                  <span className="ml-2"> Finalizar</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm11 && (
            <MDBModal
              isOpen={this.state.modalConfirm11}
              centered
              toggle={this.toggleConfirm11}
            >
              <MDBModalHeader>
                <h3>Cancelar Promoción Salud</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 10 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      Confirma que cancelar la Promoción Salud programada?
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm11}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.eliminarVisita}
                >
                  <span className="ml-2"> Cancelar Promoción</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm15 && (
            <MDBModal
              isOpen={this.state.modalConfirm15}
              centered
              toggle={this.toggleConfirm15}
            >
              <MDBModalHeader>
                <h3>PACIENTE NUEVO</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 10 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      <p>{this.state.varios.mensaje_nuevo_paciente}</p>
                      <div style={{ fontWeight: "700", marginTop: 10 }}>
                        {this.state.varios.mensaje_siguiente_cita}{" "}
                        {this.state.selHora.substring(0, 5)}
                      </div>
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm15}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.setReservaV2.bind(this)}
                >
                  <span className="ml-2"> Confirmar</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm14 && (
            <MDBModal size={"lg"} isOpen={this.state.modalConfirm14} centered>
              <MDBModalHeader>
                <h3 style={{ margin: 0 }}>Registrar Nuevo Paciente</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <>
                    <MDBRow style={{}}>
                      <MDBCol sm="12">
                        <span style={{ fontWeight: 700 }}>
                          {" "}
                          {this.state.varios.mensaje_llene_nuevo_paciente}{" "}
                        </span>
                      </MDBCol>
                    </MDBRow>
                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group card-label">
                          <label>Primer Nombre (*)</label>
                          <input
                            className={
                              "form-control " +
                              (this.state.invalids.benef_primer_nombre
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            name="benef_primer_nombre"
                            value={this.state.benef_primer_nombre}
                            onChange={this.changeHandler_B}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group card-label">
                          <label>Segundo Nombre</label>
                          <input
                            className={"form-control "}
                            type="text"
                            name="benef_segundo_nombre"
                            value={this.state.benef_segundo_nombre}
                            onChange={this.changeHandler_B}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group card-label">
                          <label>Apellido Paterno(*)</label>
                          <input
                            className={
                              "form-control " +
                              (this.state.invalids.benef_apellido_paterno
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            name="benef_apellido_paterno"
                            value={this.state.benef_apellido_paterno}
                            onChange={this.changeHandler_B}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group card-label">
                          <label>Apellido Materno</label>
                          <input
                            className={
                              "form-control " +
                              (this.state.invalids.benef_apellido_materno
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            name="benef_apellido_materno"
                            value={this.state.benef_apellido_materno}
                            onChange={this.changeHandler_B}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div
                        className="col-md-6 col-sm-12"
                        style={{ display: "flex" }}
                      >
                        <div
                          className="form-group card-label"
                          style={{ width: "60%" }}
                        >
                          <label>Cédula de Identidad(*)</label>
                          <input
                            className={
                              "form-control " +
                              (this.state.invalids.benef_cedula
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            name="benef_cedula"
                            value={this.state.benef_cedula}
                            onChange={this.changeHandler_B}
                          />
                        </div>

                        <div
                          className="form-group card-label ml-1"
                          style={{ width: "20%" }}
                        >
                          <label>Ext. </label>
                          <input
                            className={"form-control"}
                            type="text"
                            name="benef_extension"
                            value={this.state.benef_extension}
                            onChange={this.changeHandler_B}
                          />
                        </div>

                        <div
                          className="form-group card-label ml-1"
                          style={{ width: "20%" }}
                        >
                          <label>Exp. </label>
                          <select
                            defaultValue={this.state.benef_expedicion}
                            id="benef_expedicion"
                            name="benef_expedicion"
                            onChange={this.changeHandler_B}
                            className={"form-control "}
                          >
                            {this.state.v_expedicion_T.map((item) => (
                              <option
                                selected={
                                  item.value === this.state.benef_expedicion
                                    ? true
                                    : false
                                }
                                value={item.value}
                              >
                                {item.text}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group card-label">
                          <label>Parentesco </label>
                          <select
                            defaultValue={this.state.benef_parentesco}
                            style={{ width: "100%" }}
                            id="benef_parentesco"
                            name="benef_parentesco"
                            onChange={this.changeHandler_B}
                            className={"form-control "}
                          >
                            {this.state.parentescos.map((item) => (
                              <option
                                selected={
                                  item.value == this.state.benef_parentesco
                                    ? true
                                    : false
                                }
                                value={item.value}
                              >
                                {item.text}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group card-label">
                          <label>Teléfono(*)</label>
                          <input
                            className={
                              "form-control " +
                              (this.state.invalids.benef_phone
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            name="benef_phone"
                            value={this.state.benef_phone}
                            onChange={this.changeHandler_B}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group card-label">
                          <label>Email</label>
                          <input
                            className={
                              "form-control " +
                              (this.state.invalids.benef_email
                                ? "is-invalid"
                                : "")
                            }
                            type="text"
                            name="benef_email"
                            value={this.state.benef_email}
                            onChange={this.changeHandler_B}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-sm-12">
                        <div className="form-group card-label">
                          <span className="" style={{ fontSize: 14 }}>
                            Sexo del paciente
                          </span>
                          <MDBFormInline style={{ height: 45 }}>
                            <label className="">
                              <input
                                type="radio"
                                name="benef_radioGenero"
                                checked={
                                  this.state.benef_radioGenero === 1
                                    ? true
                                    : false
                                }
                                onClick={this.onClickRadioGen_B(1)}
                              />
                              <span
                                className="checkmark ml-1"
                                style={{ fontSize: 18, color: "#333" }}
                              >
                                Mujer
                              </span>
                            </label>
                            <label className="ml-2">
                              <input
                                type="radio"
                                name="benef_radioGenero"
                                checked={
                                  this.state.benef_radioGenero === 2
                                    ? true
                                    : false
                                }
                                onClick={this.onClickRadioGen_B(2)}
                              />
                              <span
                                className="checkmark ml-1"
                                style={{ fontSize: 18, color: "#333" }}
                              >
                                {" "}
                                Hombre
                              </span>
                            </label>
                          </MDBFormInline>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <label style={{ fontSize: 14 }}>
                          Fecha de Nacimiento
                        </label>
                        <MDBFormInline>
                          <label className="">
                            <select
                              defaultValue={this.state.benef_day}
                              style={{ top: -7, position: "relative" }}
                              id="benef_day"
                              name="benef_day"
                              onChange={this.changeHandler_B}
                              className={"form-control "}
                            >
                              {this.state.v_days_T.map((item) => (
                                <option
                                  selected={
                                    item.value == this.state.benef_day
                                      ? true
                                      : false
                                  }
                                  value={item.value}
                                >
                                  {item.text}
                                </option>
                              ))}
                            </select>
                          </label>
                          <label className="ml-2">
                            <select
                              defaultValue={this.state.benef_month}
                              style={{ top: -7, position: "relative" }}
                              id="benef_month"
                              name="benef_month"
                              onChange={this.changeHandler_B}
                              className={"form-control "}
                            >
                              {this.state.v_months_T.map((item) => (
                                <option
                                  selected={
                                    item.value == this.state.benef_month
                                      ? true
                                      : false
                                  }
                                  value={item.value}
                                >
                                  {item.text}
                                </option>
                              ))}
                            </select>
                          </label>
                          <label className="ml-2">
                            <select
                              defaultValue={this.state.benef_year}
                              style={{ top: -7, position: "relative" }}
                              id="benef_year"
                              name="benef_year"
                              onChange={this.changeHandler_B}
                              className={"form-control "}
                            >
                              {this.state.v_years_T.map((item) => (
                                <option
                                  selected={
                                    item.value == this.state.benef_year
                                      ? true
                                      : false
                                  }
                                  value={item.value}
                                >
                                  {item.text}
                                </option>
                              ))}
                            </select>
                          </label>
                        </MDBFormInline>
                      </div>
                    </div>

                    {this.state.servicios_nuevo.length > 1 ? (
                      <MDBRow
                        style={{
                          margin: "10px 0px 0px 0px",
                        }}
                      >
                        <MDBCol
                          md="12"
                          style={{
                            padding: 0,
                          }}
                        >
                          <div
                            className="form-group card-label  "
                            style={{ width: "100%" }}
                          >
                            <label>Planes </label>

                            <select
                              id="DocEntry"
                              name="DocEntry"
                              defaultValue={this.state.DocEntry}
                              onChange={this.changeHandler}
                              className={"form-control "}
                            >
                              {this.state.servicios_nuevo.map((item) => (
                                <option
                                  selected={
                                    this.state.DocEntry === item.DocEntry
                                  }
                                  key={"item" + item.DocEntry}
                                  value={item.DocEntry}
                                >
                                  {item.Codigo +
                                    " " +
                                    item.Nombre +
                                    "(Doc:" +
                                    item.DocEntry +
                                    ")"}
                                </option>
                              ))}
                            </select>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    ) : (
                      <MDBRow
                        style={{
                          borderTop: "1px solid #dee2e6",
                          margin: "10px 0px 0px 0px",
                        }}
                      >
                        <MDBCol
                          md="12"
                          style={{
                            padding: 0,
                          }}
                        >
                          <span style={{}}>
                            Cargando planes del Titular, espere un momento
                          </span>
                        </MDBCol>
                      </MDBRow>
                    )}
                  </>
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.guardarPaciente}
                  disabled={this.state.servicios_nuevo.length === 0}
                >
                  <span className="ml-2"> Guardar Datos</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm7 && (
            <MDBModal
              isOpen={this.state.modalConfirm7}
              centered
              toggle={this.toggleConfirm7}
            >
              <MDBModalHeader
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3>ENCUESTA</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ textAlign: "center" }}>
                    <MDBCol md="12">
                      <h4>
                        ¿Usted recomendaría nuestros servicios médicos a un
                        familiar o amigo?
                      </h4>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol md="12" className="calification-container">
                      <img
                        src={c1}
                        onClick={() => {
                          this.setCalificacion(1);
                        }}
                        alt="No1"
                      />
                      <img
                        src={c2}
                        onClick={() => {
                          this.setCalificacion(2);
                        }}
                        alt="No2"
                      />
                      <img
                        src={c3}
                        onClick={() => {
                          this.setCalificacion(3);
                        }}
                        alt="indiferente"
                      />
                      <img
                        onClick={() => {
                          this.setCalificacion(4);
                        }}
                        src={c4}
                        alt="Si2"
                      />
                      <img
                        onClick={() => {
                          this.setCalificacion(5);
                        }}
                        src={c5}
                        alt="Si1"
                        className="xxx-cal-selected"
                      />
                    </MDBCol>
                  </MDBRow>

                  <MDBRow style={{ marginBottom: "1rem" }}>
                    <MDBCol
                      md="6"
                      style={{
                        textAlign: "left",
                        fontSize: 13,
                        fontWeight: 700,
                      }}
                    >
                      No lo recomedaría
                    </MDBCol>

                    <MDBCol
                      md="6"
                      style={{
                        textAlign: "right",
                        fontSize: 13,
                        fontWeight: 700,
                      }}
                    >
                      Si lo recomedaría
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>
              {/*
              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm7}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.setCalificacion}
                > 
                  <span className="ml-2"> Registrar Calificación</span>
                </button>
              </MDBModalFooter>
               */}
            </MDBModal>
          )}

          {this.state.modalConfirm8 && (
            <MDBModal
              isOpen={this.state.modalConfirm8}
              centered
              toggle={this.toggleConfirm8}
            >
              <MDBModalHeader
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3>Seleccione un Plan</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 0 }}>
                    <MDBCol
                      md="12"
                      style={{
                        padding: "4px 0",
                        fontSize: 14,
                        fontWeight: "bold",
                      }}
                    >
                      {this.state.varios.mensaje_varios_planes}
                    </MDBCol>
                  </MDBRow>
                  {this.state.planes.map((item, index) => (
                    <MDBRow style={{ marginTop: 0 }}>
                      <MDBCol
                        md="12"
                        style={{
                          padding: "4px 0",
                          fontSize: 13,
                        }}
                      >
                        <a
                          style={{ textDecoration: "underline" }}
                          href="#"
                          onClick={() => {
                            this.setPlanPaciente(index);
                          }}
                        >
                          <h5> {"- " + item.plan}</h5>
                        </a>{" "}
                        <p>
                          {" "}
                          {" Vigencia: del " +
                            item.fechaIni +
                            " al " +
                            item.fechaFin}
                        </p>
                      </MDBCol>
                    </MDBRow>
                  ))}
                </MDBContainer>
              </MDBModalBody>
            </MDBModal>
          )}

          {this.state.modalConfirm2 && (
            <MDBModal
              isOpen={this.state.modalConfirm2}
              centered
              toggle={this.toggleConfirm2}
            >
              <MDBModalHeader>
                <h3>Nuevo Paciente</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 10 }}>
                    <MDBCol
                      md="12"
                      mt="1"
                      mb="1"
                      style={{
                        padding: "4px 0",
                      }}
                    >
                      <div style={{ fontSize: "1.2rem", fontWeight: "700" }}>
                        {this.state.mensajeNew}
                      </div>
                    </MDBCol>
                  </MDBRow>

                  {this.state.serviciosPacienteNuevo.length > 0 && (
                    <>
                      <MDBRow style={{ marginTop: 0 }}>
                        <MDBCol
                          md="12"
                          mt="1"
                          mb="1"
                          style={{
                            borderBottom: "1px solid gray",
                            padding: "4px 0",
                          }}
                        >
                          <b>Lista de servicios del Paciente:</b>
                        </MDBCol>
                      </MDBRow>
                      {this.state.serviciosPacienteNuevo.map((item) => (
                        <MDBRow style={{ marginTop: 0 }}>
                          <MDBCol
                            md="12"
                            style={{
                              padding: "4px 0",
                              fontSize: 13,
                            }}
                          >
                            <span>
                              {" "}
                              {"- " +
                                item.descripcion_servicio.split(":")[1].trim()}
                            </span>
                          </MDBCol>
                        </MDBRow>
                      ))}
                    </>
                  )}
                </MDBContainer>
              </MDBModalBody>
              <MDBModalFooter>
                {/*
							<button type="button"
								className="btn btn-primary submit-btn"
								onClick={this.enviarMensaje2}>
								<span className="ml-2"> Hacer pasar </span> 
							</button>
						*/}
                <button
                  type="button"
                  className="btn btn-secondary submit-btn"
                  onClick={this.toggleConfirm2}
                >
                  <span className="ml-2"> Cerrar</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm3 && (
            <MDBModal
              size={this.state.showNewPatient ? "lg" : "sm"}
              isOpen={this.state.modalConfirm3}
              centered
              toggle={this.toggleConfirm3}
            >
              <MDBModalHeader>
                <h3 style={{ margin: 0 }}>Finalizar atención</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  {this.state.showNewPatient ? (
                    <>
                      <MDBRow style={{}}>
                        <MDBCol sm="12">
                          <span style={{ fontWeight: 700 }}>
                            {" "}
                            {
                              this.state.varios.mensaje_llene_nuevo_paciente
                            }{" "}
                          </span>
                        </MDBCol>
                      </MDBRow>
                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="form-group card-label">
                            <label>Primer Nombre (*)</label>
                            <input
                              className={
                                "form-control " +
                                (this.state.invalids.benef_primer_nombre
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              name="benef_primer_nombre"
                              value={this.state.benef_primer_nombre}
                              onChange={this.changeHandler_B}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div className="form-group card-label">
                            <label>Segundo Nombre</label>
                            <input
                              className={"form-control "}
                              type="text"
                              name="benef_segundo_nombre"
                              value={this.state.benef_segundo_nombre}
                              onChange={this.changeHandler_B}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="form-group card-label">
                            <label>Apellido Paterno(*)</label>
                            <input
                              className={
                                "form-control " +
                                (this.state.invalids.benef_apellido_paterno
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              name="benef_apellido_paterno"
                              value={this.state.benef_apellido_paterno}
                              onChange={this.changeHandler_B}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div className="form-group card-label">
                            <label>Apellido Materno</label>
                            <input
                              className={
                                "form-control " +
                                (this.state.invalids.benef_apellido_materno
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              name="benef_apellido_materno"
                              value={this.state.benef_apellido_materno}
                              onChange={this.changeHandler_B}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ display: "flex" }}
                        >
                          <div
                            className="form-group card-label"
                            style={{ width: "60%" }}
                          >
                            <label>Cédula de Identidad(*)</label>
                            <input
                              className={
                                "form-control " +
                                (this.state.invalids.benef_cedula
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              name="benef_cedula"
                              value={this.state.benef_cedula}
                              onChange={this.changeHandler_B}
                            />
                          </div>

                          <div
                            className="form-group card-label ml-1"
                            style={{ width: "20%" }}
                          >
                            <label>Ext. </label>
                            <input
                              className={"form-control"}
                              type="text"
                              name="benef_extension"
                              value={this.state.benef_extension}
                              onChange={this.changeHandler_B}
                            />
                          </div>

                          <div
                            className="form-group card-label ml-1"
                            style={{ width: "20%" }}
                          >
                            <label>Exp. </label>
                            <select
                              defaultValue={this.state.benef_expedicion}
                              id="benef_expedicion"
                              name="benef_expedicion"
                              onChange={this.changeHandler_B}
                              className={"form-control "}
                            >
                              {this.state.v_expedicion_T.map((item) => (
                                <option
                                  selected={
                                    item.value === this.state.benef_expedicion
                                      ? true
                                      : false
                                  }
                                  value={item.value}
                                >
                                  {item.text}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div className="form-group card-label">
                            <label>Parentesco </label>
                            <select
                              defaultValue={this.state.benef_parentesco}
                              style={{ width: "100%" }}
                              id="benef_parentesco"
                              name="benef_parentesco"
                              onChange={this.changeHandler_B}
                              className={"form-control "}
                            >
                              {this.state.parentescos.map((item) => (
                                <option
                                  selected={
                                    item.value == this.state.benef_parentesco
                                      ? true
                                      : false
                                  }
                                  value={item.value}
                                >
                                  {item.text}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="form-group card-label">
                            <label>Teléfono(*)</label>
                            <input
                              className={
                                "form-control " +
                                (this.state.invalids.benef_phone
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              name="benef_phone"
                              value={this.state.benef_phone}
                              onChange={this.changeHandler_B}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div className="form-group card-label">
                            <label>Email</label>
                            <input
                              className={
                                "form-control " +
                                (this.state.invalids.benef_email
                                  ? "is-invalid"
                                  : "")
                              }
                              type="text"
                              name="benef_email"
                              value={this.state.benef_email}
                              onChange={this.changeHandler_B}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 col-sm-12">
                          <div className="form-group card-label">
                            <span className="" style={{ fontSize: 14 }}>
                              Sexo del paciente
                            </span>
                            <MDBFormInline style={{ height: 45 }}>
                              <label className="">
                                <input
                                  type="radio"
                                  name="benef_radioGenero"
                                  checked={
                                    this.state.benef_radioGenero === 1
                                      ? true
                                      : false
                                  }
                                  onClick={this.onClickRadioGen_B(1)}
                                />
                                <span
                                  className="checkmark ml-1"
                                  style={{ fontSize: 18, color: "#333" }}
                                >
                                  Mujer
                                </span>
                              </label>
                              <label className="ml-2">
                                <input
                                  type="radio"
                                  name="benef_radioGenero"
                                  checked={
                                    this.state.benef_radioGenero === 2
                                      ? true
                                      : false
                                  }
                                  onClick={this.onClickRadioGen_B(2)}
                                />
                                <span
                                  className="checkmark ml-1"
                                  style={{ fontSize: 18, color: "#333" }}
                                >
                                  {" "}
                                  Hombre
                                </span>
                              </label>
                            </MDBFormInline>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <label style={{ fontSize: 14 }}>
                            Fecha de Nacimiento
                          </label>
                          <MDBFormInline>
                            <label className="">
                              <select
                                defaultValue={this.state.benef_day}
                                style={{ top: -7, position: "relative" }}
                                id="benef_day"
                                name="benef_day"
                                onChange={this.changeHandler_B}
                                className={"form-control "}
                              >
                                {this.state.v_days_T.map((item) => (
                                  <option
                                    selected={
                                      item.value == this.state.benef_day
                                        ? true
                                        : false
                                    }
                                    value={item.value}
                                  >
                                    {item.text}
                                  </option>
                                ))}
                              </select>
                            </label>
                            <label className="ml-2">
                              <select
                                defaultValue={this.state.benef_month}
                                style={{ top: -7, position: "relative" }}
                                id="benef_month"
                                name="benef_month"
                                onChange={this.changeHandler_B}
                                className={"form-control "}
                              >
                                {this.state.v_months_T.map((item) => (
                                  <option
                                    selected={
                                      item.value == this.state.benef_month
                                        ? true
                                        : false
                                    }
                                    value={item.value}
                                  >
                                    {item.text}
                                  </option>
                                ))}
                              </select>
                            </label>
                            <label className="ml-2">
                              <select
                                defaultValue={this.state.benef_year}
                                style={{ top: -7, position: "relative" }}
                                id="benef_year"
                                name="benef_year"
                                onChange={this.changeHandler_B}
                                className={"form-control "}
                              >
                                {this.state.v_years_T.map((item) => (
                                  <option
                                    selected={
                                      item.value == this.state.benef_year
                                        ? true
                                        : false
                                    }
                                    value={item.value}
                                  >
                                    {item.text}
                                  </option>
                                ))}
                              </select>
                            </label>
                          </MDBFormInline>
                        </div>
                      </div>

                      {this.state.servicios.length > 1 && (
                        <MDBRow
                          style={{
                            borderTop: "1px solid #dee2e6",
                            margin: "10px 0px 0px 0px",
                          }}
                        >
                          <MDBCol
                            md="12"
                            mt="1"
                            mb="1"
                            style={{
                              marginLeft: -15,
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              {this.state.varios.mensaje_llene_nuevo_paciente2}{" "}
                            </span>
                          </MDBCol>
                          <MDBCol
                            md="12"
                            mt="1"
                            mb="1"
                            style={{
                              marginLeft: -15,
                            }}
                          >
                            <select
                              id="id_servicio"
                              name="id_servicio"
                              defaultValue={this.state.id_servicio}
                              onChange={this.changeHandler}
                              className={"form-control "}
                            >
                              {this.state.servicios.map((item) => (
                                <option
                                  selected={
                                    this.state.id_servicio ===
                                    item.codServInnova
                                  }
                                  key={"item" + item.codServInnova}
                                  value={item.codServInnova}
                                >
                                  {item.descripcion_servicio}
                                </option>
                              ))}
                            </select>
                          </MDBCol>
                        </MDBRow>
                      )}
                    </>
                  ) : (
                    <>
                      {this.state.servicios.length > 1 ? (
                        <MDBRow>
                          <MDBCol md="12" mt="1" mb="1">
                            Por favor, seleccione el servicio utilizado
                          </MDBCol>
                          <MDBCol md="12" mt="1" mb="1">
                            <select
                              id="id_servicio"
                              name="id_servicio"
                              defaultValue={this.state.id_servicio}
                              onChange={this.changeHandler}
                              className={"form-control "}
                            >
                              {this.state.servicios.map((item) => (
                                <option
                                  selected={
                                    this.state.id_servicio ===
                                    item.codServInnova
                                  }
                                  key={"item" + item.codServInnova}
                                  value={item.codServInnova}
                                >
                                  {item.descripcion_servicio}
                                </option>
                              ))}
                            </select>
                          </MDBCol>
                        </MDBRow>
                      ) : (
                        <MDBRow style={{ marginTop: 10 }}>
                          <MDBCol md="12" mt="1" mb="1">
                            {this.state.varios.mensaje_cerrar_atencion1}
                          </MDBCol>
                        </MDBRow>
                      )}
                    </>
                  )}
                </MDBContainer>
              </MDBModalBody>

              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm3}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.setFinAtencion}
                >
                  <span className="ml-2"> Finalizar</span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm && (
            <MDBModal
              isOpen={this.state.modalConfirm}
              centered
              toggle={this.toggleConfirm}
            >
              <MDBModalHeader>
                <h3>Confirmación de Cita</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 0 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      {this.state.tieneBenef ? (
                        <>
                          <div
                            style={{
                              fontSize: "1.05rem",
                              fontWeight: 600,
                              marginBottom: 10,
                            }}
                          >
                            {this.state.varios.mensaje_varios_usuarios_plan}
                          </div>

                          <div
                            style={{
                              border: "1px solid #777",
                              fontSize: 15,
                              padding: "0.5rem",
                              marginTop: 2,
                              cursor: "pointer",
                              background:
                                this.state.carnet_identidad_seleccionado ==
                                this.state.carnet_identidad
                                  ? "#777"
                                  : "#fff",
                              color:
                                this.state.carnet_identidad_seleccionado ==
                                this.state.carnet_identidad
                                  ? "#fff"
                                  : "#777",
                              fontWeight: 700,
                            }}
                            onClick={() => {
                              this.setCIFinal(this.state.carnet_identidad);
                            }}
                          >
                            <span>
                              {"- "}
                              {this.state.userName +
                                "  CI:" +
                                this.state.carnet_identidad}
                            </span>
                          </div>

                          {this.state.Beneficiarios.map((item) => (
                            <div
                              style={{
                                border: "1px solid gray",
                                fontSize: 15,
                                padding: "0.5rem",
                                marginTop: 2,
                                cursor: "pointer",
                                background:
                                  this.state.carnet_identidad_seleccionado ==
                                  item.NumDocumento
                                    ? "#777"
                                    : "#fff",
                                color:
                                  this.state.carnet_identidad_seleccionado ==
                                  item.NumDocumento
                                    ? "#fff"
                                    : "#777",
                                fontWeight: 700,
                              }}
                              onClick={() => {
                                this.setCIFinal(item.NumDocumento);
                              }}
                            >
                              <span>
                                {" "}
                                {"- " +
                                  item.Pnombre +
                                  " " +
                                  item.Papellido +
                                  " " +
                                  item.Sapellido +
                                  " CI:" +
                                  item.NumDocumento}
                              </span>
                            </div>
                          ))}

                          {this.state.showDependiente && (
                            <div
                              style={{
                                border: "1px solid #00cc52",
                                fontSize: 15,
                                padding: "0.5rem",
                                marginTop: 2,
                                cursor: "pointer",
                                textAlign: "center",
                                background:
                                  this.state.carnet_identidad_seleccionado ==
                                  "NUEVO"
                                    ? "#00cc52"
                                    : "#fff",
                                color:
                                  this.state.carnet_identidad_seleccionado ==
                                  "NUEVO"
                                    ? "#fff"
                                    : "#00cc52",
                                fontWeight: 700,
                              }}
                              onClick={() => {
                                this.setCIFinal("NUEVO");
                              }}
                            >
                              <span> NUEVO DEPENDIENTE</span>
                            </div>
                          )}

                          <div style={{ fontWeight: "700", marginTop: 10 }}>
                            {this.state.varios.mensaje_siguiente_cita}{" "}
                            {this.state.selHora.substring(0, 5)}
                          </div>
                        </>
                      ) : (
                        <div style={{ fontSize: "1.5rem" }}>
                          Hola {this.state.userName}, desea confirmar su reserva
                          para la(s):
                          <span style={{ fontWeight: "700" }}>
                            &nbsp; {this.state.selHora.substring(0, 5)}
                          </span>
                        </div>
                      )}
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>
              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  disabled={
                    this.state.carnet_identidad_seleccionado === "" &&
                    this.state.tieneBenef
                  }
                  className="btn btn-primary submit-btn"
                  onClick={this.setReservaV2.bind(this)}
                >
                  <span className="ml-2"> Confirmar </span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm4 && (
            <MDBModal
              isOpen={this.state.modalConfirm4}
              centered
              toggle={this.toggleConfirm4}
            >
              <MDBModalHeader>
                <h3>Programar Refrigerio</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 0 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      <div style={{ fontSize: "1.05rem" }}>
                        Seleccionar la hora de inicio del refrigerio (duración
                        máxima:30 minutos)
                      </div>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow>
                    <MDBCol md="6" sm="6">
                      <div className="form-group mini-margin card-label">
                        <label>Hora</label>
                        <select
                          name="hora"
                          className={
                            " browser-default custom-select form-control "
                          }
                          onChange={this.changeHandler}
                          value={this.state.hora}
                          defaultValue={this.state.hora}
                        >
                          {this.state.horas.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </MDBCol>
                    <MDBCol md="6" sm="6">
                      <div className="form-group mini-margin card-label">
                        <label>Minuto</label>
                        <select
                          name="minuto"
                          className={
                            " browser-default custom-select form-control "
                          }
                          onChange={this.changeHandler}
                          value={this.state.minuto}
                          defaultValue={this.state.minuto}
                        >
                          {this.state.minutos_ref.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>
              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm4}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.programarRefrigerio}
                >
                  <span className="ml-2"> Confirmar </span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.modalConfirm9 && (
            <MDBModal
              isOpen={this.state.modalConfirm9}
              centered
              toggle={this.toggleConfirm9}
            >
              <MDBModalHeader>
                <h3>Promoción Salud</h3>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer>
                  <MDBRow style={{ marginTop: 0 }}>
                    <MDBCol md="12" mt="1" mb="1">
                      <div style={{ fontSize: "1.05rem" }}>
                        Seleccionar la hora de inicio de la Promoción Salud
                      </div>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow>
                    <MDBCol md="6" sm="6">
                      <div className="form-group mini-margin card-label">
                        <label>Hora Desde</label>
                        <select
                          name="horaV"
                          className={
                            " browser-default custom-select form-control "
                          }
                          onChange={this.changeHandler}
                          value={this.state.horaV}
                          defaultValue={this.state.horaV}
                        >
                          {this.state.horas.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </MDBCol>
                    <MDBCol md="6" sm="6">
                      <div className="form-group mini-margin card-label">
                        <label>Minuto Desde</label>
                        <select
                          name="minutoV"
                          className={
                            " browser-default custom-select form-control "
                          }
                          onChange={this.changeHandler}
                          value={this.state.minutoV}
                          defaultValue={this.state.minutoV}
                        >
                          {this.state.minutos_ref.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow>
                    <MDBCol md="6" sm="6">
                      <div className="form-group mini-margin card-label">
                        <label>Hora Hasta</label>
                        <select
                          name="horaV2"
                          className={
                            " browser-default custom-select form-control "
                          }
                          onChange={this.changeHandler}
                          value={this.state.horaV2}
                          defaultValue={this.state.horaV2}
                        >
                          {this.state.horas.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </MDBCol>
                    <MDBCol md="6" sm="6">
                      <div className="form-group mini-margin card-label">
                        <label>Minuto Hasta</label>
                        <select
                          name="minutoV2"
                          className={
                            " browser-default custom-select form-control "
                          }
                          onChange={this.changeHandler}
                          value={this.state.minutoV2}
                          defaultValue={this.state.minutoV2}
                        >
                          {this.state.minutos_ref.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBModalBody>
              <MDBModalFooter>
                <button
                  type="button"
                  className="btn btn-outline-secondary submit-btn"
                  onClick={this.toggleConfirm9}
                >
                  Cancelar{" "}
                </button>

                <button
                  type="button"
                  className="btn btn-primary submit-btn"
                  onClick={this.programarVisita}
                >
                  <span className="ml-2"> Confirmar </span>
                </button>
              </MDBModalFooter>
            </MDBModal>
          )}

          {this.state.goHome ? (
            <Redirect to={{ pathname: "login-innova" }} />
          ) : (
            ""
          )}
          <Loader idLoading={this.state.isExecuting} />
          <DialogR
            icon="fas fa-plus"
            open={this.state.modalR}
            toggle={this.toggleR}
            title="Registrar Cita"
            buttons={this.state.buttonsModalR}
            userName={this.state.userName}
            plan={this.state.plan}
            consultorio={this.state.consultorio}
            doctor={this.state.doctor}
            fechaActual={this.state.fechaActual}
            horas_libres={this.state.horas_libres}
            fechaStr={this.state.fechaStr}
            carnet_identidad={this.state.carnet_identidad}
            hora={this.state.hora}
            selHora={this.state.selHora}
            setHora={this.setHora}
          />

          <div
            className="main-wrapper login-body mt-2 mb-1"
            style={{
              display: this.state.isPreparing ? "none" : "block",
              visibility: this.state.isPreparing ? "hidden" : "initial",
              transition: "ease-in all .5s",
            }}
          >
            <div className="login-wrapper">
              <div
                className={
                  this.state.rol === "Monitor" ? "Container-x" : "container"
                }
              >
                {this.state.showScreen ? (
                  <div
                    className="row flex-center "
                    style={{
                      textAlign: "center",
                      border: "1px solid #294980",
                      paddingTop: "0.5rem",
                      borderRadius: 12,
                    }}
                  >
                    <div
                      className={
                        "col-12 col-md-12 col-lg-" +
                        (this.state.showScreen ? "12" : "11") +
                        " col-xl-" +
                        (this.state.showScreen ? "12" : "10")
                      }
                    >
                      <div className="row">
                        <div
                          className={
                            " col-lg-" +
                            (this.state.rol === "Doctor" ? "6" : "8") +
                            " col-md-12 col-sm-12"
                          }
                          style={{ textAlign: "justify", minHeight: 450 }}
                        >
                          {/*!this.state.isExecuting &&*/}
                          <div
                            style={{
                              borderRadius: 10,
                              textAlign: "center",
                              border: "1px solid #e6e6e6",
                            }}
                          >
                            {!this.state.reloadV && vids.length > 0 && (
                              <>
                                {this.state.rol === "Doctor" ? (
                                  <>
                                    {this.state.serviciosPacientePantalla
                                      .length > 0 ? (
                                      <div
                                        style={{
                                          minHeight: 416,
                                          height: 416,
                                          maxHeight: 416,
                                          overflow: "hidden scroll",
                                          margin: 15,
                                        }}
                                      >
                                        <MDBRow style={{ marginTop: 0 }}>
                                          <MDBCol md="12" mt="1" mb="1">
                                            <b>Datos del Paciente en curso</b>
                                          </MDBCol>
                                        </MDBRow>

                                        <MDBRow style={{ marginTop: 0 }}>
                                          <MDBCol md="12" mt="1" mb="1">
                                            <b>Nombre:</b>{" "}
                                            {this.state.pacientePantalla}
                                          </MDBCol>
                                          <MDBCol md="12" mt="1" mb="1">
                                            <b>Cédula de identidad:</b>{" "}
                                            {this.state.cedulaPantalla}
                                          </MDBCol>
                                        </MDBRow>

                                        <MDBRow
                                          style={{
                                            marginTop: 0,
                                            marginBottom: 10,
                                          }}
                                        >
                                          <MDBCol
                                            md="12"
                                            mt="1"
                                            mb="1"
                                            style={{
                                              borderBottom: "1px solid gray",
                                              marginTop: 20,
                                            }}
                                          >
                                            <b>
                                              {this.state
                                                .serviciosPacientePantalla
                                                .length === 1
                                                ? "Servicio asignado al Paciente"
                                                : "Lista de servicios del Paciente:"}
                                            </b>
                                          </MDBCol>
                                        </MDBRow>
                                        {this.state.serviciosPacientePantalla.map(
                                          (item) => (
                                            <MDBRow style={{ marginTop: 0 }}>
                                              <MDBCol
                                                md="12"
                                                style={{
                                                  fontSize: 13,
                                                }}
                                              >
                                                <span>
                                                  {" "}
                                                  {"- " +
                                                    item.descripcion_servicio
                                                      .split(":")[1]
                                                      .trim()}
                                                </span>
                                              </MDBCol>
                                            </MDBRow>
                                          )
                                        )}
                                      </div>
                                    ) : (
                                      <img
                                        src={
                                          this.state.loginBanner || loginBanner
                                        }
                                        className="img-fluid"
                                        alt="INNOVA SALUD"
                                        style={{ borderRadius: 10 }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {this.state.refrigerioActivoMon ||
                                    this.state.visitaActivoMon ? (
                                      <>
                                        {this.state.refrigerioActivoMon && (
                                          <img
                                            src={this.state.lunchBanner}
                                            className="img-fluid"
                                            alt="INNOVA SALUD"
                                            style={{ borderRadius: 10 }}
                                          />
                                        )}
                                        {this.state.visitaActivoMon && (
                                          <img
                                            src={this.state.ausenteBanner}
                                            className="img-fluid"
                                            alt="INNOVA SALUD"
                                            style={{ borderRadius: 10 }}
                                          />
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <video
                                          id="video"
                                          ref={this.myRef}
                                          preload="true"
                                          autoplay="true"
                                          controls
                                          width="100%"
                                          height="auto"
                                          src={vids[leng - 1]}
                                        >
                                          <source
                                            src={vids[leng - 1]}
                                            type="video/mp4"
                                          />
                                        </video>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}

                            {/*<img 
														style={{													
															borderRadius: 10,
															width:"100%"
														}}
													src="/imagenes_consultios/image1.png"  className="img-fluid" alt="Logo" />*/}
                          </div>
                          {/***/}
                          <div className="mt-1">
                            {!this.state.reeloadmessage &&
                              this.state.mensaje_atraso !== "" && (
                                <ServerIO
                                  mensaje_atraso={this.state.mensaje_atraso}
                                  clearCustommessage={this.clearCustommessage}
                                  updateMessage={this.updateMessage}
                                  custommessage={this.state.custommessage}
                                  setResetMensaje={this.setResetMensaje}
                                  active={this.state.active}
                                  mensajes={this.state.mensajes}
                                  showMessage={this.showMessage}
                                  gethorasLibres={this.gethorasLibres}
                                  showCalificacion={this.showCalificacion}
                                  refrigerioActivo={this.state.refrigerioActivo}
                                  refrigerioActivoMon={
                                    this.state.refrigerioActivoMon
                                  }
                                  refrigerioMensaje={
                                    this.state.refrigerioMensaje
                                  }
                                  visitaActivo={this.state.refrigerioActivo}
                                  visitaActivoMon={this.state.visitaActivoMon}
                                  visitaMensaje={this.state.visitaMensaje}
                                />
                              )}
                            {/*this.state.rol==="Consultorio" ?
														<h3> {this.state.messageInnova}</h3>
													:
														<div className="">
															<textarea className="form-control" onChange={this.changeHandler} name="custommessage" value={this.state.custommessage}>  </textarea>
															<button 
																style={{position:"absolute",
																		right: 15,
																}}
																onClick={()=>{ this.setState({ ...this.state, showScreen: false}) }}  className="btn btn-primary mt-1" type="button">Enviar Mensaje</button>
														</div>
														*/}
                          </div>
                        </div>
                        <div
                          className={
                            "col-lg-" +
                            (this.state.rol === "Doctor" ? "6" : "4") +
                            " col-md-12 col-sm-12"
                          }
                          style={{ textAlign: "center" }}
                        >
                          <div className="">
                            <div className="row">
                              <div className="col-md-12">
                                <div
                                  className="time-slot-2"
                                  style={{ padding: "0 10px 0 0" }}
                                >
                                  <ul className="">
                                    <li style={{ padding: 0 }}>
                                      <div className="row">
                                        <div className={"col-12"}>
                                          <h3
                                            style={{ marginBottom: "0.25rem" }}
                                          >
                                            AGENDA MÉDICA
                                          </h3>
                                        </div>
                                      </div>
                                    </li>

                                    <li>
                                      <div className="row time-slot-2-header">
                                        <div className={"col-2"}>Hora</div>
                                        <div className={"col-3"}>Cédula</div>
                                        <div
                                          className={
                                            this.state.rol === "Doctor"
                                              ? "col-5"
                                              : "col-6"
                                          }
                                        >
                                          Paciente
                                        </div>
                                        {this.state.rol === "Doctor" && (
                                          <div className={"col-2"}>Acción</div>
                                        )}
                                      </div>
                                    </li>
                                    {this.state.horas_libres.map(
                                      (item, idx) => {
                                        let total =
                                          this.state.horas_libres.length;
                                        let current = 0;
                                        let isValid = true;

                                        if (total > 13) {
                                          let curr = 0;
                                          for (let i in this.state
                                            .horas_libres) {
                                            if (
                                              this.state.horas_libres[i].now
                                            ) {
                                              curr = i - 1;
                                            }
                                          }

                                          let diffUp = total - curr;
                                          let diffDown = parseInt(14) - diffUp;

                                          //console.log("diffUp",diffUp,diffDown)
                                          if (diffDown < 0) {
                                            diffDown = 0;
                                            diffUp = 12;
                                          }

                                          if (idx + diffDown < parseInt(curr)) {
                                            isValid = false;
                                          }

                                          if (idx > parseInt(curr) + diffUp) {
                                            isValid = false;
                                          }
                                        }

                                        if (item.atendido === "E") {
                                          isValid = true;
                                        }
                                        //  console.log("isValid",idx,item,isValid)

                                        return (
                                          isValid && (
                                            <li style={{ padding: 0 }}>
                                              <div
                                                className="row"
                                                style={{ borderBottom: "0" }}
                                              >
                                                <div
                                                  className={"col-2  cedula"}
                                                  key={"horaLnk1" + item.key}
                                                  style={{ padding: 0 }}
                                                >
                                                  <span>
                                                    {item.cedula === "Visita" ||
                                                    item.cedula === "Refrigerio"
                                                      ? item.datosExtra1.hora_reservada.substr(
                                                          0,
                                                          5
                                                        )
                                                      : item.hora_larga.substr(
                                                          0,
                                                          5
                                                        )}{" "}
                                                  </span>
                                                </div>

                                                <div
                                                  onClick={() => {
                                                    if (
                                                      item.atendido === "N" &&
                                                      item.cedula !==
                                                        "Refrigerio" &&
                                                      item.cedula !==
                                                        "Visita" &&
                                                      !this.state
                                                        .refrigerioActivoMon
                                                    ) {
                                                      this.sendMessage(
                                                        item.cedula === "NUEVO"
                                                          ? item.datosExtra1
                                                              .usuario_registro
                                                          : item.cedula,
                                                        item.paciente,
                                                        item.id
                                                      );
                                                    } else {
                                                      if (
                                                        item.cedula ===
                                                          "Refrigerio" &&
                                                        item.atendido !== "E" &&
                                                        this.state.noBreakVisit
                                                      ) {
                                                        this.setState({
                                                          ...this.state,
                                                          modalConfirm12: true,
                                                          idRef: item.id,
                                                        });
                                                      }

                                                      if (
                                                        item.cedula ===
                                                          "Visita" &&
                                                        item.atendido !== "E" &&
                                                        this.state.noBreakVisit
                                                      ) {
                                                        this.setState({
                                                          ...this.state,
                                                          modalConfirm13: true,
                                                          idVis: item.id,
                                                        });
                                                      }
                                                    }

                                                    if (
                                                      item.free &&
                                                      this.state.noBreak
                                                    ) {
                                                      this.setBreak(
                                                        item.hora_larga
                                                      );
                                                    }
                                                  }}
                                                  className={
                                                    (item.datosExtra1?.tipo ===
                                                      "RANGODIAHORA" ||
                                                    item.datosExtra1?.tipo ===
                                                      "DIASEMANA" ||
                                                    item.datosExtra1?.tipo ===
                                                      "DIA" ||
                                                    item.datosExtra1?.tipo ===
                                                      "HORASEMANA" ||
                                                    item.datosExtra1?.tipo ===
                                                      "EXCEPCIONHORARIO" ||
                                                    item.datosExtra1?.tipo ===
                                                      "HORADIASEMANA"
                                                      ? "col-10 "
                                                      : "col-3 ") +
                                                    (item.next || item.selected
                                                      ? " timing-selected"
                                                      : "") +
                                                    (item.expired
                                                      ? item.estado ===
                                                        "vencida"
                                                        ? " timing-gray"
                                                        : item.datosExtra1
                                                            ?.tipo ===
                                                            "RANGODIAHORA" ||
                                                          item.datosExtra1
                                                            ?.tipo ===
                                                            "DIASEMANA" ||
                                                          item.datosExtra1
                                                            ?.tipo === "DIA" ||
                                                          item.datosExtra1
                                                            ?.tipo ===
                                                            "HORASEMANA" ||
                                                          item.datosExtra1
                                                            ?.tipo ===
                                                            "EXCEPCIONHORARIO" ||
                                                          item.datosExtra1
                                                            ?.tipo ===
                                                            "HORADIASEMANA"
                                                        ? " timing-gray"
                                                        : " timing-expire"
                                                      : "") +
                                                    (item.free
                                                      ? item.datosExtra1
                                                          ?.tipo ===
                                                          "RANGODIAHORA" ||
                                                        item.datosExtra1
                                                          ?.tipo ===
                                                          "DIASEMANA" ||
                                                        item.datosExtra1
                                                          ?.tipo === "DIA" ||
                                                        item.datosExtra1
                                                          ?.tipo ===
                                                          "HORASEMANA" ||
                                                        item.datosExtra1
                                                          ?.tipo ===
                                                          "EXCEPCIONHORARIO" ||
                                                        item.datosExtra1
                                                          ?.tipo ===
                                                          "HORADIASEMANA"
                                                        ? " timing-gray"
                                                        : " timing-free"
                                                      : "") +
                                                    (item.current
                                                      ? " timing-current"
                                                      : "")
                                                  }
                                                  style={{
                                                    padding: 0,
                                                    cursor:
                                                      item.atendido === "N" ||
                                                      (item.free &&
                                                        this.state.noBreak)
                                                        ? "pointer"
                                                        : "no-drop",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  {item.cedula
                                                    ? item.cedula === "NUEVO"
                                                      ? item.datosExtra1
                                                          .usuario_registro
                                                      : item.cedula === "Visita"
                                                      ? "Promoción"
                                                      : item.cedula
                                                    : ""}

                                                  {item.datosExtra1?.tipo ===
                                                    "RANGODIAHORA" ||
                                                  item.datosExtra1?.tipo ===
                                                    "DIASEMANA" ||
                                                  item.datosExtra1?.tipo ===
                                                    "DIA" ||
                                                  item.datosExtra1?.tipo ===
                                                    "HORASEMANA" ||
                                                  item.datosExtra1?.tipo ===
                                                    "EXCEPCIONHORARIO" ||
                                                  item.datosExtra1?.tipo ===
                                                    "HORADIASEMANA"
                                                    ? item.datosExtra1?.nombre
                                                    : ""}
                                                </div>

                                                {item.datosExtra1?.tipo ===
                                                  "RANGODIAHORA" ||
                                                item.datosExtra1?.tipo ===
                                                  "DIASEMANA" ||
                                                item.datosExtra1?.tipo ===
                                                  "DIA" ||
                                                item.datosExtra1?.tipo ===
                                                  "HORASEMANA" ||
                                                item.datosExtra1?.tipo ===
                                                  "EXCEPCIONHORARIO" ||
                                                item.datosExtra1?.tipo ===
                                                  "HORADIASEMANA" ? (
                                                  <></>
                                                ) : (
                                                  <>
                                                    <div
                                                      className={
                                                        this.state.rol ===
                                                        "Doctor"
                                                          ? "col-5"
                                                          : "col-6"
                                                      }
                                                      style={{
                                                        padding: "2px 0 0 4px",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {item.paciente === "libre"
                                                        ? ""
                                                        : item.paciente.substr(
                                                            0,
                                                            50
                                                          )}
                                                    </div>

                                                    {this.state.rol ===
                                                      "Doctor" && (
                                                      <div
                                                        className={"col-2"}
                                                        key={
                                                          "horaLnk2" + item.key
                                                        }
                                                        style={{
                                                          padding: 0,
                                                          display: "flex",
                                                          justifyContent:
                                                            "center",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        {item.atendido ===
                                                        "E" ? (
                                                          <>
                                                            {item.cedula ===
                                                              "Refrigerio" ||
                                                            item.cedula ===
                                                              "Visita" ? (
                                                              <>
                                                                {item.cedula ===
                                                                  "Refrigerio" && (
                                                                  <button
                                                                    onClick={() => {
                                                                      this.setState(
                                                                        {
                                                                          ...this
                                                                            .state,
                                                                          modalConfirm5: true,
                                                                          idRef:
                                                                            item.id,
                                                                        }
                                                                      );
                                                                    }}
                                                                    className="btn btn-sm btn-success"
                                                                    type="button"
                                                                  >
                                                                    Finalizar
                                                                    Refrigerio
                                                                  </button>
                                                                )}

                                                                {item.cedula ===
                                                                  "Visita" && (
                                                                  <button
                                                                    onClick={() => {
                                                                      this.setState(
                                                                        {
                                                                          ...this
                                                                            .state,
                                                                          modalConfirm10: true,
                                                                          idVis:
                                                                            item.id,
                                                                        }
                                                                      );
                                                                    }}
                                                                    className="btn btn-sm btn-success"
                                                                    type="button"
                                                                  >
                                                                    Finalizar
                                                                    Promoción
                                                                  </button>
                                                                )}
                                                              </>
                                                            ) : (
                                                              <>
                                                                {item.paciente ===
                                                                "NUEVO PACIENTE" ? (
                                                                  <button
                                                                    onClick={() => {
                                                                      this.buscarDatosNuevoPaciente(
                                                                        item.id
                                                                      );
                                                                    }}
                                                                    className="btn btn-sm btn-success"
                                                                    type="button"
                                                                  >
                                                                    Actualizar
                                                                  </button>
                                                                ) : (
                                                                  <button
                                                                    onClick={() => {
                                                                      this.cerrarConsulta(
                                                                        item.id
                                                                      );
                                                                    }}
                                                                    className="btn btn-sm btn-success"
                                                                    type="button"
                                                                  >
                                                                    Finalizar
                                                                  </button>
                                                                )}
                                                              </>
                                                            )}
                                                          </>
                                                        ) : (
                                                          <></>
                                                        )}
                                                      </div>
                                                    )}
                                                  </>
                                                )}
                                              </div>
                                            </li>
                                          )
                                        );
                                      }
                                    )}
                                  </ul>
                                </div>

                                <div style={{ textAlign: "justify" }}>
                                  <div className="row mt-1">
                                    <div
                                      className="col-1"
                                      style={{
                                        background: "#3deae8",
                                        borderRadius: 5,
                                      }}
                                    ></div>
                                    <div
                                      className="col-5"
                                      style={{ fontSize: "0.85rem" }}
                                    >
                                      Horas Atendidas
                                    </div>

                                    <div
                                      className="col-1"
                                      style={{
                                        background: "#f1c40f",
                                        borderRadius: 5,
                                      }}
                                    ></div>
                                    <div
                                      className="col-5"
                                      style={{ fontSize: "0.85rem" }}
                                    >
                                      Cita Agendada
                                    </div>
                                  </div>
                                  <div className="row mt-1">
                                    <div
                                      className="col-1"
                                      style={{
                                        background: "#00cc52",
                                        borderRadius: 5,
                                      }}
                                    ></div>
                                    <div
                                      className="col-5"
                                      style={{ fontSize: "0.85rem" }}
                                    >
                                      Atención en Curso
                                    </div>

                                    <div
                                      className="col-1"
                                      style={{
                                        background: "#ffeb9d",
                                        borderRadius: 5,
                                      }}
                                    ></div>
                                    <div
                                      className="col-5"
                                      style={{ fontSize: "0.85rem" }}
                                    >
                                      Horas disponible
                                    </div>
                                  </div>
                                  <div
                                    className="row mt-1"
                                    style={{ marginLeft: -30 }}
                                  >
                                    {this.state.usuario_rol === "Doctor" && (
                                      <div
                                        className="col-6"
                                        style={{ fontSize: "0.85rem" }}
                                      >
                                        {this.state.existeRefrigerio ? (
                                          <button
                                            onClick={() => {
                                              this.setState({
                                                ...this.state,
                                                modalConfirm6: true,
                                              });
                                            }}
                                            className="btn btn-sm btn-danger btm-sm"
                                            type="button"
                                          >
                                            Cancelar Refrigerio
                                          </button>
                                        ) : (
                                          <>
                                            {this.state.refrigerioActivo ? (
                                              <button
                                                onClick={() => {
                                                  this.setState({
                                                    ...this.state,
                                                    modalConfirm5: true,
                                                  });
                                                }}
                                                className="btn btn-sm btn-success btm-sm"
                                                type="button"
                                              >
                                                Finalizar Refrigerio
                                              </button>
                                            ) : (
                                              !this.state.refrigerioActivoMon &&
                                              !this.state.lookRefrigerio && (
                                                <button
                                                  onClick={() => {
                                                    let fechaActual =
                                                      new Date();
                                                    let horas =
                                                      fechaActual.getHours();
                                                    let hora_actual = horas
                                                      .toString()
                                                      .padStart(2, "0");

                                                    this.setState({
                                                      ...this.state,
                                                      modalConfirm4: true,
                                                      hora: hora_actual,
                                                      minuto: "00",
                                                    });
                                                  }}
                                                  className="btn btn-sm btn-info btm-sm"
                                                  type="button"
                                                >
                                                  Programar Refrigerio
                                                </button>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                    )}

                                    {this.state.usuario_rol === "Doctor" && (
                                      <div
                                        className="col-6"
                                        style={{ fontSize: "0.85rem" }}
                                      >
                                        {this.state.existeVisita ? (
                                          <button
                                            onClick={() => {
                                              this.setState({
                                                ...this.state,
                                                modalConfirm11: true,
                                              });
                                            }}
                                            className="btn btn-sm btn-danger btm-sm"
                                            type="button"
                                          >
                                            Cancelar Promoción Salud
                                          </button>
                                        ) : (
                                          <>
                                            {this.state.visitaActivo ? (
                                              <button
                                                onClick={() => {
                                                  this.setState({
                                                    ...this.state,
                                                    modalConfirm10: true,
                                                  });
                                                }}
                                                className="btn btn-sm btn-success btm-sm"
                                                type="button"
                                              >
                                                Finalizar Promoción
                                              </button>
                                            ) : (
                                              !this.state.lookRef2 && (
                                                <button
                                                  onClick={() => {
                                                    let fechaActual =
                                                      new Date();
                                                    let horas =
                                                      fechaActual.getHours();
                                                    let hora_actual = horas
                                                      .toString()
                                                      .padStart(2, "0");

                                                    this.setState({
                                                      ...this.state,
                                                      modalConfirm9: true,
                                                      horaV: hora_actual,
                                                      minutoV: "00",
                                                      horaV2: hora_actual,
                                                      minutoV2: "00",
                                                    });
                                                  }}
                                                  className="btn btn-sm btn-info btm-sm"
                                                  type="button"
                                                >
                                                  Programar Promoción
                                                </button>
                                              )
                                            )}
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    className="row "
                                    style={{ marginLeft: -30 }}
                                  >
                                    <div
                                      className="col-12"
                                      style={{ fontSize: 12 }}
                                    >
                                      {this.state.rol === "Doctor" && (
                                        <>
                                          {this.state.varios
                                            ? this.state.varios
                                                .mensaje_doctor_refrigerio
                                            : ""}{" "}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.rol === "Consultorio" && (
                        <div className="row mt-1">
                          <div
                            className="mb-1 col-lg-12 col-md-12 col-sm-12"
                            style={{ textAlign: "right", padding: "10px 0" }}
                          >
                            <div>
                              <>
                                {!this.state.lockReservas ? (
                                  <h3> {this.state.mensaje_fuera_horario}</h3>
                                ) : (
                                  <button
                                    onClick={() => {
                                      this.setState({
                                        ...this.state,
                                        showScreen: false,
                                      });
                                    }}
                                    className="btn btn-primary"
                                    type="button"
                                  >
                                    Reservar Cita
                                  </button>
                                )}
                              </>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className="row flex-center "
                    style={{ textAlign: "center" }}
                  >
                    <div className="col-12 col-md-12 col-lg-12 col-xl-10">
                      <div className="row pt-4 pb-5">
                        <div className="col-12 col-md-12 col-lg-12 flex-center flex-middle">
                          <h1 style={{ fontSize: "2.5rem" }}>BIENVENIDO</h1>

                          <ServerIO
                            mensaje_atraso={this.state.mensaje_atraso}
                            clearCustommessage={this.clearCustommessage}
                            updateMessage={this.updateMessafge}
                            custommessage={this.state.custommessage}
                            setResetMensaje={this.setResetMensaje}
                            active={this.state.active}
                            mensajes={this.state.mensajes}
                            showMessage={this.showMessage}
                            gethorasLibres={this.gethorasLibres}
                            showCalificacion={this.showCalificacion}
                            refrigerioActivo={this.state.refrigerioActivo}
                            refrigerioActivoMon={this.state.refrigerioActivoMon}
                            refrigerioMensaje={this.state.refrigerioMensaje}
                            visitaActivo={this.state.visitaActivo}
                            visitaActivoMon={this.state.visitaActivoMon}
                            visitaMensaje={this.state.visitaMensaje}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 col-md-9 col-lg-9 flex-middle">
                          <div>
                            <div
                              className="form-group flex-center"
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "600",
                              }}
                            >
                              <div
                                style={{
                                  width: "97%",
                                }}
                              >
                                {this.state.mensaje_bienvenida_reserva}
                              </div>
                            </div>
                            <div className="form-group flex-center mt-3">
                              <input
                                style={{
                                  height: 55,
                                  fontSize: "1.25rem",
                                  width: "97%",
                                }}
                                onChange={this.changeHandler}
                                onKeyDown={this.changeHandler}
                                /*disabled={this.state.step1}*/
                                value={this.state.carnet_identidad}
                                name="carnet_identidad"
                                className="form-control"
                                type="text"
                                readOnly={true}
                                placeholder="Carnet de Identidad"
                              />
                            </div>

                            <div className="keyboard  mt-3">
                              <div className="keys">
                                {Array.from({ length: 9 }, (_, i) => (
                                  <button
                                    key={i + 1}
                                    className="key"
                                    onClick={() => this.handleClick(i + 1)}
                                  >
                                    {i + 1}
                                  </button>
                                ))}
                                <button
                                  key={0}
                                  className="key"
                                  onClick={() => this.handleClick(0)}
                                >
                                  0
                                </button>
                                <button
                                  key={0}
                                  style={{ width: 90 }}
                                  className="key"
                                  onClick={() =>
                                    this.setState({
                                      carnet_identidad: "",
                                      checkPlanPatient: null,
                                      benefClinic: [],
                                    })
                                  }
                                >
                                  {"Borrar"}
                                </button>
                              </div>
                            </div>

                            {/*this.state.step1 && (
                              <div className="form-group">
                                <select
                                  id="id_servicio"
                                  name="id_servicio"
                                  defaultValue={this.state.id_servicio}
                                  onChange={this.changeHandler}
                                  className={
                                    "form-control " +
                                    (this.state.invalidServ ? "is-invalid" : "")
                                  }
                                >
                                  <option
                                    selected={this.state.id_servicio === 0}
                                  >
                                    {"Seleccione el tipo de servicio"}
                                  </option>
                                  {this.state.servicios.map((item) => (
                                    <option
                                      selected={
                                        this.state.id_servicio === item.codSAP
                                      }
                                      key={"item" + item.codSAP}
                                      value={item.codSAP}
                                    >
                                      {item.descripcion_servicio} (Duración:
                                      {item.duracion_consulta || 30} minutos)
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )*/}
                            <div className="form-group mt-3 flex-center">
                              {this.state.step1 ? (
                                <>
                                  {this.state.lockReservas ? (
                                    <h3> {this.state.mensaje_fuera_horario}</h3>
                                  ) : (
                                    <button
                                      style={{
                                        padding: "0.25rem",
                                        fontSize: "1.75rem",
                                        width: "97%",
                                      }}
                                      onClick={this.buscarPaciente}
                                      className="btn btn-success btn-block"
                                      type="button"
                                    >
                                      Reservar Cita
                                    </button>
                                  )}
                                  {/**
                                  <button
                                    style={{
                                      padding: "0.25rem",
                                      fontSize: "1.75rem",
                                    }}
                                    onClick={() => {
                                      this.setState({
                                        step1: false,
                                        carnet_identidad: "",
                                      });
                                    }}
                                    className="btn btn-outlined-success btn-block"
                                    type="button"
                                  >
                                    Ingresar un nuevo CI
                                  </button>
                                   */}
                                </>
                              ) : (
                                <>
                                  {this.state.lockReservas ? (
                                    <h3> {this.state.mensaje_fuera_horario}</h3>
                                  ) : (
                                    <button
                                      style={{
                                        padding: "0.25rem",
                                        fontSize: "1.75rem",
                                      }}
                                      onClick={this.buscarCI}
                                      className="btn btn-success mt-2 btn-block"
                                      type="button"
                                    >
                                      Buscar mis servicios
                                    </button>
                                  )}{" "}
                                </>
                              )}
                            </div>
                            {/*"aqui el boton"*/}
                          </div>
                        </div>
                        <div className="col-12 col-md-3 col-lg-3 flex-middle">
                          <img src={IMG01} className="img-fluid" alt="Logo" />
                        </div>
                      </div>
                      {this.state.errorLogin ? (
                        <div className="row">
                          <div className="col-9">
                            <div
                              className="alert alert-danger alert-dismissible fade show"
                              role="alert"
                            >
                              <p>
                                <span> {this.state.errorMessage}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.modalSucc && (
                        <div className="row">
                          <div className="col-12 col-md-8 col-lg-8">
                            <div
                              className="alert alert-success alert-dismissible fade show mt-1"
                              role="alert"
                            >
                              <h4>
                                <span> {this.state.cita_reservada}</span>
                              </h4>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {this.state.showCalificacionButton && (
          <button
            style={{
              padding: "0.25rem",
              fontSize: "1.75rem",
              height: "4.75rem",
              width: "13rem",
              lineHeight: 1,

              position: "absolute",
              zIndex: 100,
              right: 35,
              marginTop: 20,
            }}
            onClick={() => {
              this.setState({
                modalConfirm7: true,
              });
            }}
            className="btn btn-info btn-block"
            type="button"
          >
            Calificar su consulta
          </button>
        )}
      </>
    );
  }
}
export default Reservations;
